/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.3.0 (NJsonSchema v10.6.4.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { Dictionary } from '../../models';

export class AdresseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param postcode (optional) 
     * @return Success
     */
    searchAdresse(query: string, postcode: string | undefined, cancelToken?: CancelToken | undefined): Promise<GeoAdresseDto[]> {
        let url_ = this.baseUrl + "/api/v1/Adresse/search?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (postcode === null)
            throw new Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAdresse(_response);
        });
    }

    protected processSearchAdresse(response: AxiosResponse): Promise<GeoAdresseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeoAdresseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeoAdresseDto[]>(<any>null);
    }
}

export class ArtisteClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getArtiste(artisteId: string, cancelToken?: CancelToken | undefined): Promise<ArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArtiste(_response);
        });
    }

    protected processGetArtiste(response: AxiosResponse): Promise<ArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ArtisteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArtisteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArtiste(artisteId: string, body: UpdateArtisteDto | undefined, cancelToken?: CancelToken | undefined): Promise<ArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArtiste(_response);
        });
    }

    protected processUpdateArtiste(response: AxiosResponse): Promise<ArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ArtisteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArtisteDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteArtiste(artisteId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteArtiste(_response);
        });
    }

    protected processDeleteArtiste(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param dossierId (optional) 
     * @param search (optional) 
     * @return Success
     */
    autocompleteArtiste(dossierId: string | undefined, search: string | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Artiste/autocomplete?";
        if (dossierId === null)
            throw new Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutocompleteArtiste(_response);
        });
    }

    protected processAutocompleteArtiste(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<string[]>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class AuthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginDto | undefined, cancelToken?: CancelToken | undefined): Promise<FOCurrentUserDto> {
        let url_ = this.baseUrl + "/api/v1/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<FOCurrentUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<FOCurrentUserDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401 = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FOCurrentUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    logout(cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Auth/password/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: PasswordResetRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Auth/password/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePasswordWithResetToken(body: ChangePasswordWithResetTokenDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Auth/password/reset/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePasswordWithResetToken(_response);
        });
    }

    protected processChangePasswordWithResetToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BanqueClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param iban (optional) 
     * @return Success
     */
    validateIban(iban: string | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Banque/validate-account?";
        if (iban === null)
            throw new Error("The parameter 'iban' cannot be null.");
        else if (iban !== undefined)
            url_ += "iban=" + encodeURIComponent("" + iban) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateIban(_response);
        });
    }

    protected processValidateIban(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class DossierClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param disablePagination (optional) 
     * @return Success
     */
    getDossiers(filters: string | undefined, sorts: string | undefined, page: number | undefined, pageSize: number | undefined, disablePagination: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<DossierDtoSortedFilteredPage> {
        let url_ = this.baseUrl + "/api/v1/Dossier?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDossiers(_response);
        });
    }

    protected processGetDossiers(response: AxiosResponse): Promise<DossierDtoSortedFilteredPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierDtoSortedFilteredPage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierDtoSortedFilteredPage>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDossier(body: CreateDossierDto | undefined, cancelToken?: CancelToken | undefined): Promise<DossierDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDossier(_response);
        });
    }

    protected processCreateDossier(response: AxiosResponse): Promise<DossierDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentDossierInfo(dossierId: string, cancelToken?: CancelToken | undefined): Promise<CurrentDossierInfoDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/currentDossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentDossierInfo(_response);
        });
    }

    protected processGetCurrentDossierInfo(response: AxiosResponse): Promise<CurrentDossierInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<CurrentDossierInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentDossierInfoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDossierDetails(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DossierDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/details";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDossierDetails(_response);
        });
    }

    protected processGetDossierDetails(response: AxiosResponse): Promise<DossierDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    renonciationDossier(dossierId: string, commentaire: string | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/renonciation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

            const content_ = new FormData();
            content_.append("json", JSON.stringify({ commentaire: commentaire ?? "" }));
        let options_ = <AxiosRequestConfig>{
            method: "POST",
            data: content_,
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenonciationDossier(_response);
        });
    }

    protected processRenonciationDossier(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    duplicationDossier(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DossierDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/duplicate";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicationDossier(_response);
        });
    }

    protected processDuplicationDossier(response: AxiosResponse): Promise<DossierDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentCritereDossier(categorieId: string, cancelToken?: CancelToken | undefined): Promise<CurrentCritereDossierDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/categorie/{categorieId}/critere";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentCritereDossier(_response);
        });
    }

    protected processGetCurrentCritereDossier(response: AxiosResponse): Promise<CurrentCritereDossierDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<CurrentCritereDossierDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentCritereDossierDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDossierCommission(dossierId: string, cancelToken?: CancelToken | undefined): Promise<CommissionDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/commission";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDossierCommission(_response);
        });
    }

    protected processGetDossierCommission(response: AxiosResponse): Promise<CommissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<CommissionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommissionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrestation(dossierId: string, body: CreateLieuDto | undefined, cancelToken?: CancelToken | undefined): Promise<LieuDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePrestation(_response);
        });
    }

    protected processCreatePrestation(response: AxiosResponse): Promise<LieuDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<LieuDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createArtiste(dossierId: string, body: CreateArtisteDto | undefined, cancelToken?: CancelToken | undefined): Promise<ArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artiste";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateArtiste(_response);
        });
    }

    protected processCreateArtiste(response: AxiosResponse): Promise<ArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<ArtisteDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArtisteDto>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param ville (optional) 
     * @param disciplines (optional) 
     * @param otherDiscipline (optional) 
     * @param instrumentId (optional) 
     * @param qualification (optional) 
     * @param typeContrat (optional) 
     * @param statut (optional) 
     * @param remunerationBruteAnnuelle (optional) 
     * @param montantChargesPatronales (optional) 
     * @param tarifHoraireBrut (optional) 
     * @param remunerationPremierTrimestre (optional) 
     * @param contratEngagement_Id (optional) 
     * @param contratEngagement_TypeId (optional) 
     * @param contratEngagement_PartName (optional) 
     * @param contratEngagement_ExtraInfos (optional) 
     * @param contratEngagement_FileName (optional) 
     * @param contratEngagement_ContentType (optional) 
     * @param contratEngagement_Content_CanRead (optional) 
     * @param contratEngagement_Content_CanWrite (optional) 
     * @param contratEngagement_Content_CanSeek (optional) 
     * @param contratEngagement_Content_CanTimeout (optional) 
     * @param contratEngagement_Content_Length (optional) 
     * @param contratEngagement_Content_Position (optional) 
     * @param contratEngagement_Content_ReadTimeout (optional) 
     * @param contratEngagement_Content_WriteTimeout (optional) 
     * @param justificatifRemuneration_Id (optional) 
     * @param justificatifRemuneration_TypeId (optional) 
     * @param justificatifRemuneration_PartName (optional) 
     * @param justificatifRemuneration_ExtraInfos (optional) 
     * @param justificatifRemuneration_FileName (optional) 
     * @param justificatifRemuneration_ContentType (optional) 
     * @param justificatifRemuneration_Content_CanRead (optional) 
     * @param justificatifRemuneration_Content_CanWrite (optional) 
     * @param justificatifRemuneration_Content_CanSeek (optional) 
     * @param justificatifRemuneration_Content_CanTimeout (optional) 
     * @param justificatifRemuneration_Content_Length (optional) 
     * @param justificatifRemuneration_Content_Position (optional) 
     * @param justificatifRemuneration_Content_ReadTimeout (optional) 
     * @param justificatifRemuneration_Content_WriteTimeout (optional) 
     * @param documents (optional) 
     * @return Success
     */
    createEnseignant(dossierId: string, nom: string | undefined, prenom: string | undefined, ville: string | undefined, disciplines: string[] | undefined, otherDiscipline: string | undefined, instrumentId: string | undefined, qualification: QualificationEnseignant | undefined, typeContrat: TypeContrat | undefined, statut: StatutEnseignant | undefined, remunerationBruteAnnuelle: number | undefined, montantChargesPatronales: number | undefined, tarifHoraireBrut: number | undefined, remunerationPremierTrimestre: number | undefined, contratEngagement_Id: string | undefined, contratEngagement_TypeId: string | undefined, contratEngagement_PartName: string | undefined, contratEngagement_ExtraInfos: { [key: string]: any; } | undefined, contratEngagement_FileName: string | undefined, contratEngagement_ContentType: string | undefined, contratEngagement_Content_CanRead: boolean | undefined, contratEngagement_Content_CanWrite: boolean | undefined, contratEngagement_Content_CanSeek: boolean | undefined, contratEngagement_Content_CanTimeout: boolean | undefined, contratEngagement_Content_Length: number | undefined, contratEngagement_Content_Position: number | undefined, contratEngagement_Content_ReadTimeout: number | undefined, contratEngagement_Content_WriteTimeout: number | undefined, justificatifRemuneration_Id: string | undefined, justificatifRemuneration_TypeId: string | undefined, justificatifRemuneration_PartName: string | undefined, justificatifRemuneration_ExtraInfos: { [key: string]: any; } | undefined, justificatifRemuneration_FileName: string | undefined, justificatifRemuneration_ContentType: string | undefined, justificatifRemuneration_Content_CanRead: boolean | undefined, justificatifRemuneration_Content_CanWrite: boolean | undefined, justificatifRemuneration_Content_CanSeek: boolean | undefined, justificatifRemuneration_Content_CanTimeout: boolean | undefined, justificatifRemuneration_Content_Length: number | undefined, justificatifRemuneration_Content_Position: number | undefined, justificatifRemuneration_Content_ReadTimeout: number | undefined, justificatifRemuneration_Content_WriteTimeout: number | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<EnseignantDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnseignant(_response);
        });
    }

    protected processCreateEnseignant(response: AxiosResponse): Promise<EnseignantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<EnseignantDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantDto>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param ville (optional) 
     * @param disciplines (optional) 
     * @param otherDiscipline (optional) 
     * @param instrumentId (optional) 
     * @param qualification (optional) 
     * @param typeContrat (optional) 
     * @param statut (optional) 
     * @param remunerationBruteAnnuelle (optional) 
     * @param montantChargesPatronales (optional) 
     * @param tarifHoraireBrut (optional) 
     * @param remunerationPremierTrimestre (optional) 
     * @param contratEngagement_Id (optional) 
     * @param contratEngagement_TypeId (optional) 
     * @param contratEngagement_PartName (optional) 
     * @param contratEngagement_ExtraInfos (optional) 
     * @param contratEngagement_FileName (optional) 
     * @param contratEngagement_ContentType (optional) 
     * @param contratEngagement_Content_CanRead (optional) 
     * @param contratEngagement_Content_CanWrite (optional) 
     * @param contratEngagement_Content_CanSeek (optional) 
     * @param contratEngagement_Content_CanTimeout (optional) 
     * @param contratEngagement_Content_Length (optional) 
     * @param contratEngagement_Content_Position (optional) 
     * @param contratEngagement_Content_ReadTimeout (optional) 
     * @param contratEngagement_Content_WriteTimeout (optional) 
     * @param justificatifRemuneration_Id (optional) 
     * @param justificatifRemuneration_TypeId (optional) 
     * @param justificatifRemuneration_PartName (optional) 
     * @param justificatifRemuneration_ExtraInfos (optional) 
     * @param justificatifRemuneration_FileName (optional) 
     * @param justificatifRemuneration_ContentType (optional) 
     * @param justificatifRemuneration_Content_CanRead (optional) 
     * @param justificatifRemuneration_Content_CanWrite (optional) 
     * @param justificatifRemuneration_Content_CanSeek (optional) 
     * @param justificatifRemuneration_Content_CanTimeout (optional) 
     * @param justificatifRemuneration_Content_Length (optional) 
     * @param justificatifRemuneration_Content_Position (optional) 
     * @param justificatifRemuneration_Content_ReadTimeout (optional) 
     * @param justificatifRemuneration_Content_WriteTimeout (optional) 
     * @param documents (optional) 
     * @return Success
     */
    updateEnseignant(dossierId: string, enseignantId: string, nom: string | undefined, prenom: string | undefined, ville: string | undefined, disciplines: string[] | undefined, otherDiscipline: string | undefined, instrumentId: string | undefined, qualification: QualificationEnseignant | undefined, typeContrat: TypeContrat | undefined, statut: StatutEnseignant | undefined, remunerationBruteAnnuelle: number | undefined, montantChargesPatronales: number | undefined, tarifHoraireBrut: number | undefined, remunerationPremierTrimestre: number | undefined, contratEngagement_Id: string | undefined, contratEngagement_TypeId: string | undefined, contratEngagement_PartName: string | undefined, contratEngagement_ExtraInfos: { [key: string]: any; } | undefined, contratEngagement_FileName: string | undefined, contratEngagement_ContentType: string | undefined, contratEngagement_Content_CanRead: boolean | undefined, contratEngagement_Content_CanWrite: boolean | undefined, contratEngagement_Content_CanSeek: boolean | undefined, contratEngagement_Content_CanTimeout: boolean | undefined, contratEngagement_Content_Length: number | undefined, contratEngagement_Content_Position: number | undefined, contratEngagement_Content_ReadTimeout: number | undefined, contratEngagement_Content_WriteTimeout: number | undefined, justificatifRemuneration_Id: string | undefined, justificatifRemuneration_TypeId: string | undefined, justificatifRemuneration_PartName: string | undefined, justificatifRemuneration_ExtraInfos: { [key: string]: any; } | undefined, justificatifRemuneration_FileName: string | undefined, justificatifRemuneration_ContentType: string | undefined, justificatifRemuneration_Content_CanRead: boolean | undefined, justificatifRemuneration_Content_CanWrite: boolean | undefined, justificatifRemuneration_Content_CanSeek: boolean | undefined, justificatifRemuneration_Content_CanTimeout: boolean | undefined, justificatifRemuneration_Content_Length: number | undefined, justificatifRemuneration_Content_Position: number | undefined, justificatifRemuneration_Content_ReadTimeout: number | undefined, justificatifRemuneration_Content_WriteTimeout: number | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<EnseignantDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/{enseignantId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnseignant(_response);
        });
    }

    protected processUpdateEnseignant(response: AxiosResponse): Promise<EnseignantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EnseignantDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEnseignant(dossierId: string, enseignantId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/{enseignantId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnseignant(_response);
        });
    }

    protected processDeleteEnseignant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePrestation(prestationId: string, body: UpdateLieuDto | undefined, cancelToken?: CancelToken | undefined): Promise<LieuDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/prestation/{prestationId}";
        if (prestationId === undefined || prestationId === null)
            throw new Error("The parameter 'prestationId' must be defined.");
        url_ = url_.replace("{prestationId}", encodeURIComponent("" + prestationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePrestation(_response);
        });
    }

    protected processUpdatePrestation(response: AxiosResponse): Promise<LieuDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<LieuDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuDto>(<any>null);
    }

    /**
     * @return Success
     */
    deletePrestation(prestationId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/prestation/{prestationId}";
        if (prestationId === undefined || prestationId === null)
            throw new Error("The parameter 'prestationId' must be defined.");
        url_ = url_.replace("{prestationId}", encodeURIComponent("" + prestationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePrestation(_response);
        });
    }

    protected processDeletePrestation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEtapesCreationDossier(categorieId: string, cancelToken?: CancelToken | undefined): Promise<EtapeCreationDossier[]> {
        let url_ = this.baseUrl + "/api/v1/Dossier/categorie/{categorieId}/etapes";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEtapesCreationDossier(_response);
        });
    }

    protected processGetEtapesCreationDossier(response: AxiosResponse): Promise<EtapeCreationDossier[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EtapeCreationDossier[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EtapeCreationDossier[]>(<any>null);
    }

    /**
     * @param answers (optional) 
     * @param files (optional) 
     * @return Success
     */
    submitInfosProjetAnswers(dossierId: string, answers: { [key: string]: any; } | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/informationsProjet/answers";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            content_.append("Answers", JSON.stringify(answers));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitInfosProjetAnswers(_response);
        });
    }

    protected processSubmitInfosProjetAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setResponsableDossier(dossierId: string, body: CreateOrUpdateResponsableDossierDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/responsable";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetResponsableDossier(_response);
        });
    }

    protected processSetResponsableDossier(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param answers (optional) 
     * @param files (optional) 
     * @return Success
     */
    submitDescriptionProjetAnswers(dossierId: string, answers: { [key: string]: any; } | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/descriptionProjet/answers";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            content_.append("Answers", JSON.stringify(answers));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitDescriptionProjetAnswers(_response);
        });
    }

    protected processSubmitDescriptionProjetAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param commentaire (optional) 
     * @param documents (optional) 
     * @param depenses (optional) 
     * @param financements (optional) 
     * @param files (optional) 
     * @return Success
     */
    createBudget(dossierId: string, commentaire: string | undefined, documents: DocumentUploadInfoDto[] | undefined, depenses: CreateDepenseDto[] | undefined, financements: CreateFinancementDto[] | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commentaire === null || commentaire === undefined)
            throw new Error("The parameter 'commentaire' cannot be null.");
        else
            content_.append("Commentaire", commentaire.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (depenses === null || depenses === undefined)
            throw new Error("The parameter 'depenses' cannot be null.");
        else
            depenses.forEach(item_ => content_.append("Depenses", item_.toString()));
        if (financements === null || financements === undefined)
            throw new Error("The parameter 'financements' cannot be null.");
        else
            financements.forEach(item_ => content_.append("Financements", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBudget(_response);
        });
    }

    protected processCreateBudget(response: AxiosResponse): Promise<BudgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<BudgetDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BudgetDto>(<any>null);
    }

    /**
     * @param commentaire (optional) 
     * @param documents (optional) 
     * @param depenses (optional) 
     * @param financements (optional) 
     * @param files (optional) 
     * @return Success
     */
    updateBudget(dossierId: string, commentaire: string | undefined, documents: DocumentUploadInfoDto[] | undefined, depenses: UpdateDepenseDto[] | undefined, financements: UpdateFinancementDto[] | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (commentaire === null || commentaire === undefined)
            throw new Error("The parameter 'commentaire' cannot be null.");
        else
            content_.append("Commentaire", commentaire.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (depenses === null || depenses === undefined)
            throw new Error("The parameter 'depenses' cannot be null.");
        else
            depenses.forEach(item_ => content_.append("Depenses", item_.toString()));
        if (financements === null || financements === undefined)
            throw new Error("The parameter 'financements' cannot be null.");
        else
            financements.forEach(item_ => content_.append("Financements", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBudget(_response);
        });
    }

    protected processUpdateBudget(response: AxiosResponse): Promise<BudgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<BudgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BudgetDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDossierBudget(dossierId: string, cancelToken?: CancelToken | undefined): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDossierBudget(_response);
        });
    }

    protected processGetDossierBudget(response: AxiosResponse): Promise<BudgetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<BudgetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BudgetDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBudgetViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<BudgetViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetViewModel(_response);
        });
    }

    protected processGetBudgetViewModel(response: AxiosResponse): Promise<BudgetViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<BudgetViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BudgetViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPrestationsViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<PrestationsViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestations/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrestationsViewModel(_response);
        });
    }

    protected processGetPrestationsViewModel(response: AxiosResponse): Promise<PrestationsViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<PrestationsViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrestationsViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLieux(dossierId: string, cancelToken?: CancelToken | undefined): Promise<LieuxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/lieux";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLieux(_response);
        });
    }

    protected processGetLieux(response: AxiosResponse): Promise<LieuxDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<LieuxDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuxDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDossierPays(dossierId: string, cancelToken?: CancelToken | undefined): Promise<PaysDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/pays";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDossierPays(_response);
        });
    }

    protected processGetDossierPays(response: AxiosResponse): Promise<PaysDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<PaysDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaysDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    validatePrestations(dossierId: string, cancelToken?: CancelToken | undefined): Promise<LieuValidationDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestations/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidatePrestations(_response);
        });
    }

    protected processValidatePrestations(response: AxiosResponse): Promise<LieuValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<LieuValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuValidationDto>(<any>null);
    }

    /**
     * @return Success
     */
    validateArtistes(dossierId: string, cancelToken?: CancelToken | undefined): Promise<ArtistesValidationDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateArtistes(_response);
        });
    }

    protected processValidateArtistes(response: AxiosResponse): Promise<ArtistesValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ArtistesValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArtistesValidationDto>(<any>null);
    }

    /**
     * @return Success
     */
    validateEnseignants(dossierId: string, cancelToken?: CancelToken | undefined): Promise<EnseignantValidationDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateEnseignants(_response);
        });
    }

    protected processValidateEnseignants(response: AxiosResponse): Promise<EnseignantValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EnseignantValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantValidationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createChiffresCles(dossierId: string, body: CreateChiffresClesDto | undefined, cancelToken?: CancelToken | undefined): Promise<ChiffresClesDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/chiffresCles";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChiffresCles(_response);
        });
    }

    protected processCreateChiffresCles(response: AxiosResponse): Promise<ChiffresClesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ChiffresClesDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChiffresClesDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAidesFonctionnement(dossierId: string, body: CreateOrUpdateAidesFonctionnementDto | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/aidesFonctionnement";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateAidesFonctionnement(_response);
        });
    }

    protected processCreateOrUpdateAidesFonctionnement(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    getChiffresClesViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<ChiffresClesViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/chiffresCles/viewModel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChiffresClesViewModel(_response);
        });
    }

    protected processGetChiffresClesViewModel(response: AxiosResponse): Promise<ChiffresClesViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ChiffresClesViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChiffresClesViewModelDto>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param email (optional) 
     * @param adresse_Line1 (optional) 
     * @param adresse_Line2 (optional) 
     * @param adresse_CodePostal (optional) 
     * @param adresse_Ville (optional) 
     * @param dateNaissance (optional) 
     * @param dateEmbauchePrevue (optional) 
     * @param salaireBrut (optional) 
     * @param cV_Id (optional) 
     * @param cV_TypeId (optional) 
     * @param cV_PartName (optional) 
     * @param cV_ExtraInfos (optional) 
     * @param cV_FileName (optional) 
     * @param cV_ContentType (optional) 
     * @param cV_Content_CanRead (optional) 
     * @param cV_Content_CanWrite (optional) 
     * @param cV_Content_CanSeek (optional) 
     * @param cV_Content_CanTimeout (optional) 
     * @param cV_Content_Length (optional) 
     * @param cV_Content_Position (optional) 
     * @param cV_Content_ReadTimeout (optional) 
     * @param cV_Content_WriteTimeout (optional) 
     * @param diplome_Id (optional) 
     * @param diplome_TypeId (optional) 
     * @param diplome_PartName (optional) 
     * @param diplome_ExtraInfos (optional) 
     * @param diplome_FileName (optional) 
     * @param diplome_ContentType (optional) 
     * @param diplome_Content_CanRead (optional) 
     * @param diplome_Content_CanWrite (optional) 
     * @param diplome_Content_CanSeek (optional) 
     * @param diplome_Content_CanTimeout (optional) 
     * @param diplome_Content_Length (optional) 
     * @param diplome_Content_Position (optional) 
     * @param diplome_Content_ReadTimeout (optional) 
     * @param diplome_Content_WriteTimeout (optional) 
     * @param conventionCollective (optional) 
     * @param equipements (optional) 
     * @param autresEquipements (optional) 
     * @param typesAdresses (optional) 
     * @param autreAdresse_Line1 (optional) 
     * @param autreAdresse_Line2 (optional) 
     * @param autreAdresse_CodePostal (optional) 
     * @param autreAdresse_Ville (optional) 
     * @param documents (optional) 
     * @return Success
     */
    createSalarie(dossierId: string, nom: string | undefined, prenom: string | undefined, email: string | undefined, adresse_Line1: string | undefined, adresse_Line2: string | undefined, adresse_CodePostal: string | undefined, adresse_Ville: string | undefined, dateNaissance: Date | undefined, dateEmbauchePrevue: Date | undefined, salaireBrut: number | undefined, cV_Id: string | undefined, cV_TypeId: string | undefined, cV_PartName: string | undefined, cV_ExtraInfos: { [key: string]: any; } | undefined, cV_FileName: string | undefined, cV_ContentType: string | undefined, cV_Content_CanRead: boolean | undefined, cV_Content_CanWrite: boolean | undefined, cV_Content_CanSeek: boolean | undefined, cV_Content_CanTimeout: boolean | undefined, cV_Content_Length: number | undefined, cV_Content_Position: number | undefined, cV_Content_ReadTimeout: number | undefined, cV_Content_WriteTimeout: number | undefined, diplome_Id: string | undefined, diplome_TypeId: string | undefined, diplome_PartName: string | undefined, diplome_ExtraInfos: { [key: string]: any; } | undefined, diplome_FileName: string | undefined, diplome_ContentType: string | undefined, diplome_Content_CanRead: boolean | undefined, diplome_Content_CanWrite: boolean | undefined, diplome_Content_CanSeek: boolean | undefined, diplome_Content_CanTimeout: boolean | undefined, diplome_Content_Length: number | undefined, diplome_Content_Position: number | undefined, diplome_Content_ReadTimeout: number | undefined, diplome_Content_WriteTimeout: number | undefined, conventionCollective: string | undefined, equipements: Equipements | undefined, autresEquipements: string | undefined, typesAdresses: TypesAdresses | undefined, autreAdresse_Line1: string | undefined, autreAdresse_Line2: string | undefined, autreAdresse_CodePostal: string | undefined, autreAdresse_Ville: string | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<SalarieDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/salarie";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (dateNaissance === null || dateNaissance === undefined)
            throw new Error("The parameter 'dateNaissance' cannot be null.");
        else
            content_.append("DateNaissance", dateNaissance.toJSON());
        if (dateEmbauchePrevue === null || dateEmbauchePrevue === undefined)
            throw new Error("The parameter 'dateEmbauchePrevue' cannot be null.");
        else
            content_.append("DateEmbauchePrevue", dateEmbauchePrevue.toJSON());
        if (salaireBrut === null || salaireBrut === undefined)
            throw new Error("The parameter 'salaireBrut' cannot be null.");
        else
            content_.append("SalaireBrut", salaireBrut.toString());
        if (cV_Id === null || cV_Id === undefined)
            throw new Error("The parameter 'cV_Id' cannot be null.");
        else
            content_.append("CV.Id", cV_Id.toString());
        if (cV_TypeId === null || cV_TypeId === undefined)
            throw new Error("The parameter 'cV_TypeId' cannot be null.");
        else
            content_.append("CV.TypeId", cV_TypeId.toString());
        if (cV_PartName === null || cV_PartName === undefined)
            throw new Error("The parameter 'cV_PartName' cannot be null.");
        else
            content_.append("CV.PartName", cV_PartName.toString());
        if (cV_ExtraInfos === null || cV_ExtraInfos === undefined)
            throw new Error("The parameter 'cV_ExtraInfos' cannot be null.");
        else
            content_.append("CV.ExtraInfos", JSON.stringify(cV_ExtraInfos));
        if (cV_FileName === null || cV_FileName === undefined)
            throw new Error("The parameter 'cV_FileName' cannot be null.");
        else
            content_.append("CV.FileName", cV_FileName.toString());
        if (cV_ContentType === null || cV_ContentType === undefined)
            throw new Error("The parameter 'cV_ContentType' cannot be null.");
        else
            content_.append("CV.ContentType", cV_ContentType.toString());
        if (cV_Content_CanRead === null || cV_Content_CanRead === undefined)
            throw new Error("The parameter 'cV_Content_CanRead' cannot be null.");
        else
            content_.append("CV.Content.CanRead", cV_Content_CanRead.toString());
        if (cV_Content_CanWrite === null || cV_Content_CanWrite === undefined)
            throw new Error("The parameter 'cV_Content_CanWrite' cannot be null.");
        else
            content_.append("CV.Content.CanWrite", cV_Content_CanWrite.toString());
        if (cV_Content_CanSeek === null || cV_Content_CanSeek === undefined)
            throw new Error("The parameter 'cV_Content_CanSeek' cannot be null.");
        else
            content_.append("CV.Content.CanSeek", cV_Content_CanSeek.toString());
        if (cV_Content_CanTimeout === null || cV_Content_CanTimeout === undefined)
            throw new Error("The parameter 'cV_Content_CanTimeout' cannot be null.");
        else
            content_.append("CV.Content.CanTimeout", cV_Content_CanTimeout.toString());
        if (cV_Content_Length === null || cV_Content_Length === undefined)
            throw new Error("The parameter 'cV_Content_Length' cannot be null.");
        else
            content_.append("CV.Content.Length", cV_Content_Length.toString());
        if (cV_Content_Position === null || cV_Content_Position === undefined)
            throw new Error("The parameter 'cV_Content_Position' cannot be null.");
        else
            content_.append("CV.Content.Position", cV_Content_Position.toString());
        if (cV_Content_ReadTimeout === null || cV_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'cV_Content_ReadTimeout' cannot be null.");
        else
            content_.append("CV.Content.ReadTimeout", cV_Content_ReadTimeout.toString());
        if (cV_Content_WriteTimeout === null || cV_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'cV_Content_WriteTimeout' cannot be null.");
        else
            content_.append("CV.Content.WriteTimeout", cV_Content_WriteTimeout.toString());
        if (diplome_Id === null || diplome_Id === undefined)
            throw new Error("The parameter 'diplome_Id' cannot be null.");
        else
            content_.append("Diplome.Id", diplome_Id.toString());
        if (diplome_TypeId === null || diplome_TypeId === undefined)
            throw new Error("The parameter 'diplome_TypeId' cannot be null.");
        else
            content_.append("Diplome.TypeId", diplome_TypeId.toString());
        if (diplome_PartName === null || diplome_PartName === undefined)
            throw new Error("The parameter 'diplome_PartName' cannot be null.");
        else
            content_.append("Diplome.PartName", diplome_PartName.toString());
        if (diplome_ExtraInfos === null || diplome_ExtraInfos === undefined)
            throw new Error("The parameter 'diplome_ExtraInfos' cannot be null.");
        else
            content_.append("Diplome.ExtraInfos", JSON.stringify(diplome_ExtraInfos));
        if (diplome_FileName === null || diplome_FileName === undefined)
            throw new Error("The parameter 'diplome_FileName' cannot be null.");
        else
            content_.append("Diplome.FileName", diplome_FileName.toString());
        if (diplome_ContentType === null || diplome_ContentType === undefined)
            throw new Error("The parameter 'diplome_ContentType' cannot be null.");
        else
            content_.append("Diplome.ContentType", diplome_ContentType.toString());
        if (diplome_Content_CanRead === null || diplome_Content_CanRead === undefined)
            throw new Error("The parameter 'diplome_Content_CanRead' cannot be null.");
        else
            content_.append("Diplome.Content.CanRead", diplome_Content_CanRead.toString());
        if (diplome_Content_CanWrite === null || diplome_Content_CanWrite === undefined)
            throw new Error("The parameter 'diplome_Content_CanWrite' cannot be null.");
        else
            content_.append("Diplome.Content.CanWrite", diplome_Content_CanWrite.toString());
        if (diplome_Content_CanSeek === null || diplome_Content_CanSeek === undefined)
            throw new Error("The parameter 'diplome_Content_CanSeek' cannot be null.");
        else
            content_.append("Diplome.Content.CanSeek", diplome_Content_CanSeek.toString());
        if (diplome_Content_CanTimeout === null || diplome_Content_CanTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_CanTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.CanTimeout", diplome_Content_CanTimeout.toString());
        if (diplome_Content_Length === null || diplome_Content_Length === undefined)
            throw new Error("The parameter 'diplome_Content_Length' cannot be null.");
        else
            content_.append("Diplome.Content.Length", diplome_Content_Length.toString());
        if (diplome_Content_Position === null || diplome_Content_Position === undefined)
            throw new Error("The parameter 'diplome_Content_Position' cannot be null.");
        else
            content_.append("Diplome.Content.Position", diplome_Content_Position.toString());
        if (diplome_Content_ReadTimeout === null || diplome_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.ReadTimeout", diplome_Content_ReadTimeout.toString());
        if (diplome_Content_WriteTimeout === null || diplome_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.WriteTimeout", diplome_Content_WriteTimeout.toString());
        if (conventionCollective === null || conventionCollective === undefined)
            throw new Error("The parameter 'conventionCollective' cannot be null.");
        else
            content_.append("ConventionCollective", conventionCollective.toString());
        if (equipements === null || equipements === undefined)
            throw new Error("The parameter 'equipements' cannot be null.");
        else
            content_.append("Equipements", equipements.toString());
        if (autresEquipements === null || autresEquipements === undefined)
            throw new Error("The parameter 'autresEquipements' cannot be null.");
        else
            content_.append("AutresEquipements", autresEquipements.toString());
        if (typesAdresses === null || typesAdresses === undefined)
            throw new Error("The parameter 'typesAdresses' cannot be null.");
        else
            content_.append("TypesAdresses", typesAdresses.toString());
        if (autreAdresse_Line1 === null || autreAdresse_Line1 === undefined)
            throw new Error("The parameter 'autreAdresse_Line1' cannot be null.");
        else
            content_.append("AutreAdresse.Line1", autreAdresse_Line1.toString());
        if (autreAdresse_Line2 === null || autreAdresse_Line2 === undefined)
            throw new Error("The parameter 'autreAdresse_Line2' cannot be null.");
        else
            content_.append("AutreAdresse.Line2", autreAdresse_Line2.toString());
        if (autreAdresse_CodePostal === null || autreAdresse_CodePostal === undefined)
            throw new Error("The parameter 'autreAdresse_CodePostal' cannot be null.");
        else
            content_.append("AutreAdresse.CodePostal", autreAdresse_CodePostal.toString());
        if (autreAdresse_Ville === null || autreAdresse_Ville === undefined)
            throw new Error("The parameter 'autreAdresse_Ville' cannot be null.");
        else
            content_.append("AutreAdresse.Ville", autreAdresse_Ville.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSalarie(_response);
        });
    }

    protected processCreateSalarie(response: AxiosResponse): Promise<SalarieDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<SalarieDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalarieDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSalarie(dossierId: string, cancelToken?: CancelToken | undefined): Promise<SalarieDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/salarie";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalarie(_response);
        });
    }

    protected processGetSalarie(response: AxiosResponse): Promise<SalarieDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<SalarieDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalarieDto>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param adresse_Line1 (optional) 
     * @param adresse_Line2 (optional) 
     * @param adresse_CodePostal (optional) 
     * @param adresse_Ville (optional) 
     * @param dateNaissance (optional) 
     * @param dateEmbauchePrevue (optional) 
     * @param salaireBrut (optional) 
     * @param cV_Id (optional) 
     * @param cV_TypeId (optional) 
     * @param cV_PartName (optional) 
     * @param cV_ExtraInfos (optional) 
     * @param cV_FileName (optional) 
     * @param cV_ContentType (optional) 
     * @param cV_Content_CanRead (optional) 
     * @param cV_Content_CanWrite (optional) 
     * @param cV_Content_CanSeek (optional) 
     * @param cV_Content_CanTimeout (optional) 
     * @param cV_Content_Length (optional) 
     * @param cV_Content_Position (optional) 
     * @param cV_Content_ReadTimeout (optional) 
     * @param cV_Content_WriteTimeout (optional) 
     * @param diplome_Id (optional) 
     * @param diplome_TypeId (optional) 
     * @param diplome_PartName (optional) 
     * @param diplome_ExtraInfos (optional) 
     * @param diplome_FileName (optional) 
     * @param diplome_ContentType (optional) 
     * @param diplome_Content_CanRead (optional) 
     * @param diplome_Content_CanWrite (optional) 
     * @param diplome_Content_CanSeek (optional) 
     * @param diplome_Content_CanTimeout (optional) 
     * @param diplome_Content_Length (optional) 
     * @param diplome_Content_Position (optional) 
     * @param diplome_Content_ReadTimeout (optional) 
     * @param diplome_Content_WriteTimeout (optional) 
     * @param conventionCollective (optional) 
     * @param equipements (optional) 
     * @param autresEquipements (optional) 
     * @param typesAdresses (optional) 
     * @param autreAdresse_Line1 (optional) 
     * @param autreAdresse_Line2 (optional) 
     * @param autreAdresse_CodePostal (optional) 
     * @param autreAdresse_Ville (optional) 
     * @param documents (optional) 
     * @return Success
     */
    updateSalarie(salarieId: string, nom: string | undefined, prenom: string | undefined, adresse_Line1: string | undefined, adresse_Line2: string | undefined, adresse_CodePostal: string | undefined, adresse_Ville: string | undefined, dateNaissance: Date | undefined, dateEmbauchePrevue: Date | undefined, salaireBrut: number | undefined, cV_Id: string | undefined, cV_TypeId: string | undefined, cV_PartName: string | undefined, cV_ExtraInfos: { [key: string]: any; } | undefined, cV_FileName: string | undefined, cV_ContentType: string | undefined, cV_Content_CanRead: boolean | undefined, cV_Content_CanWrite: boolean | undefined, cV_Content_CanSeek: boolean | undefined, cV_Content_CanTimeout: boolean | undefined, cV_Content_Length: number | undefined, cV_Content_Position: number | undefined, cV_Content_ReadTimeout: number | undefined, cV_Content_WriteTimeout: number | undefined, diplome_Id: string | undefined, diplome_TypeId: string | undefined, diplome_PartName: string | undefined, diplome_ExtraInfos: { [key: string]: any; } | undefined, diplome_FileName: string | undefined, diplome_ContentType: string | undefined, diplome_Content_CanRead: boolean | undefined, diplome_Content_CanWrite: boolean | undefined, diplome_Content_CanSeek: boolean | undefined, diplome_Content_CanTimeout: boolean | undefined, diplome_Content_Length: number | undefined, diplome_Content_Position: number | undefined, diplome_Content_ReadTimeout: number | undefined, diplome_Content_WriteTimeout: number | undefined, conventionCollective: string | undefined, equipements: Equipements | undefined, autresEquipements: string | undefined, typesAdresses: TypesAdresses | undefined, autreAdresse_Line1: string | undefined, autreAdresse_Line2: string | undefined, autreAdresse_CodePostal: string | undefined, autreAdresse_Ville: string | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<SalarieDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/salarie/{salarieId}";
        if (salarieId === undefined || salarieId === null)
            throw new Error("The parameter 'salarieId' must be defined.");
        url_ = url_.replace("{salarieId}", encodeURIComponent("" + salarieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (dateNaissance === null || dateNaissance === undefined)
            throw new Error("The parameter 'dateNaissance' cannot be null.");
        else
            content_.append("DateNaissance", dateNaissance.toJSON());
        if (dateEmbauchePrevue === null || dateEmbauchePrevue === undefined)
            throw new Error("The parameter 'dateEmbauchePrevue' cannot be null.");
        else
            content_.append("DateEmbauchePrevue", dateEmbauchePrevue.toJSON());
        if (salaireBrut === null || salaireBrut === undefined)
            throw new Error("The parameter 'salaireBrut' cannot be null.");
        else
            content_.append("SalaireBrut", salaireBrut.toString());
        if (cV_Id === null || cV_Id === undefined)
            throw new Error("The parameter 'cV_Id' cannot be null.");
        else
            content_.append("CV.Id", cV_Id.toString());
        if (cV_TypeId === null || cV_TypeId === undefined)
            throw new Error("The parameter 'cV_TypeId' cannot be null.");
        else
            content_.append("CV.TypeId", cV_TypeId.toString());
        if (cV_PartName === null || cV_PartName === undefined)
            throw new Error("The parameter 'cV_PartName' cannot be null.");
        else
            content_.append("CV.PartName", cV_PartName.toString());
        if (cV_ExtraInfos === null || cV_ExtraInfos === undefined)
            throw new Error("The parameter 'cV_ExtraInfos' cannot be null.");
        else
            content_.append("CV.ExtraInfos", JSON.stringify(cV_ExtraInfos));
        if (cV_FileName === null || cV_FileName === undefined)
            throw new Error("The parameter 'cV_FileName' cannot be null.");
        else
            content_.append("CV.FileName", cV_FileName.toString());
        if (cV_ContentType === null || cV_ContentType === undefined)
            throw new Error("The parameter 'cV_ContentType' cannot be null.");
        else
            content_.append("CV.ContentType", cV_ContentType.toString());
        if (cV_Content_CanRead === null || cV_Content_CanRead === undefined)
            throw new Error("The parameter 'cV_Content_CanRead' cannot be null.");
        else
            content_.append("CV.Content.CanRead", cV_Content_CanRead.toString());
        if (cV_Content_CanWrite === null || cV_Content_CanWrite === undefined)
            throw new Error("The parameter 'cV_Content_CanWrite' cannot be null.");
        else
            content_.append("CV.Content.CanWrite", cV_Content_CanWrite.toString());
        if (cV_Content_CanSeek === null || cV_Content_CanSeek === undefined)
            throw new Error("The parameter 'cV_Content_CanSeek' cannot be null.");
        else
            content_.append("CV.Content.CanSeek", cV_Content_CanSeek.toString());
        if (cV_Content_CanTimeout === null || cV_Content_CanTimeout === undefined)
            throw new Error("The parameter 'cV_Content_CanTimeout' cannot be null.");
        else
            content_.append("CV.Content.CanTimeout", cV_Content_CanTimeout.toString());
        if (cV_Content_Length === null || cV_Content_Length === undefined)
            throw new Error("The parameter 'cV_Content_Length' cannot be null.");
        else
            content_.append("CV.Content.Length", cV_Content_Length.toString());
        if (cV_Content_Position === null || cV_Content_Position === undefined)
            throw new Error("The parameter 'cV_Content_Position' cannot be null.");
        else
            content_.append("CV.Content.Position", cV_Content_Position.toString());
        if (cV_Content_ReadTimeout === null || cV_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'cV_Content_ReadTimeout' cannot be null.");
        else
            content_.append("CV.Content.ReadTimeout", cV_Content_ReadTimeout.toString());
        if (cV_Content_WriteTimeout === null || cV_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'cV_Content_WriteTimeout' cannot be null.");
        else
            content_.append("CV.Content.WriteTimeout", cV_Content_WriteTimeout.toString());
        if (diplome_Id === null || diplome_Id === undefined)
            throw new Error("The parameter 'diplome_Id' cannot be null.");
        else
            content_.append("Diplome.Id", diplome_Id.toString());
        if (diplome_TypeId === null || diplome_TypeId === undefined)
            throw new Error("The parameter 'diplome_TypeId' cannot be null.");
        else
            content_.append("Diplome.TypeId", diplome_TypeId.toString());
        if (diplome_PartName === null || diplome_PartName === undefined)
            throw new Error("The parameter 'diplome_PartName' cannot be null.");
        else
            content_.append("Diplome.PartName", diplome_PartName.toString());
        if (diplome_ExtraInfos === null || diplome_ExtraInfos === undefined)
            throw new Error("The parameter 'diplome_ExtraInfos' cannot be null.");
        else
            content_.append("Diplome.ExtraInfos", JSON.stringify(diplome_ExtraInfos));
        if (diplome_FileName === null || diplome_FileName === undefined)
            throw new Error("The parameter 'diplome_FileName' cannot be null.");
        else
            content_.append("Diplome.FileName", diplome_FileName.toString());
        if (diplome_ContentType === null || diplome_ContentType === undefined)
            throw new Error("The parameter 'diplome_ContentType' cannot be null.");
        else
            content_.append("Diplome.ContentType", diplome_ContentType.toString());
        if (diplome_Content_CanRead === null || diplome_Content_CanRead === undefined)
            throw new Error("The parameter 'diplome_Content_CanRead' cannot be null.");
        else
            content_.append("Diplome.Content.CanRead", diplome_Content_CanRead.toString());
        if (diplome_Content_CanWrite === null || diplome_Content_CanWrite === undefined)
            throw new Error("The parameter 'diplome_Content_CanWrite' cannot be null.");
        else
            content_.append("Diplome.Content.CanWrite", diplome_Content_CanWrite.toString());
        if (diplome_Content_CanSeek === null || diplome_Content_CanSeek === undefined)
            throw new Error("The parameter 'diplome_Content_CanSeek' cannot be null.");
        else
            content_.append("Diplome.Content.CanSeek", diplome_Content_CanSeek.toString());
        if (diplome_Content_CanTimeout === null || diplome_Content_CanTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_CanTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.CanTimeout", diplome_Content_CanTimeout.toString());
        if (diplome_Content_Length === null || diplome_Content_Length === undefined)
            throw new Error("The parameter 'diplome_Content_Length' cannot be null.");
        else
            content_.append("Diplome.Content.Length", diplome_Content_Length.toString());
        if (diplome_Content_Position === null || diplome_Content_Position === undefined)
            throw new Error("The parameter 'diplome_Content_Position' cannot be null.");
        else
            content_.append("Diplome.Content.Position", diplome_Content_Position.toString());
        if (diplome_Content_ReadTimeout === null || diplome_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.ReadTimeout", diplome_Content_ReadTimeout.toString());
        if (diplome_Content_WriteTimeout === null || diplome_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.WriteTimeout", diplome_Content_WriteTimeout.toString());
        if (conventionCollective === null || conventionCollective === undefined)
            throw new Error("The parameter 'conventionCollective' cannot be null.");
        else
            content_.append("ConventionCollective", conventionCollective.toString());
        if (equipements === null || equipements === undefined)
            throw new Error("The parameter 'equipements' cannot be null.");
        else
            content_.append("Equipements", equipements.toString());
        if (autresEquipements === null || autresEquipements === undefined)
            throw new Error("The parameter 'autresEquipements' cannot be null.");
        else
            content_.append("AutresEquipements", autresEquipements.toString());
        if (typesAdresses === null || typesAdresses === undefined)
            throw new Error("The parameter 'typesAdresses' cannot be null.");
        else
            content_.append("TypesAdresses", typesAdresses.toString());
        if (autreAdresse_Line1 === null || autreAdresse_Line1 === undefined)
            throw new Error("The parameter 'autreAdresse_Line1' cannot be null.");
        else
            content_.append("AutreAdresse.Line1", autreAdresse_Line1.toString());
        if (autreAdresse_Line2 === null || autreAdresse_Line2 === undefined)
            throw new Error("The parameter 'autreAdresse_Line2' cannot be null.");
        else
            content_.append("AutreAdresse.Line2", autreAdresse_Line2.toString());
        if (autreAdresse_CodePostal === null || autreAdresse_CodePostal === undefined)
            throw new Error("The parameter 'autreAdresse_CodePostal' cannot be null.");
        else
            content_.append("AutreAdresse.CodePostal", autreAdresse_CodePostal.toString());
        if (autreAdresse_Ville === null || autreAdresse_Ville === undefined)
            throw new Error("The parameter 'autreAdresse_Ville' cannot be null.");
        else
            content_.append("AutreAdresse.Ville", autreAdresse_Ville.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSalarie(_response);
        });
    }

    protected processUpdateSalarie(response: AxiosResponse): Promise<SalarieDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<SalarieDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalarieDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSalarie(salarieId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/salarie/{salarieId}";
        if (salarieId === undefined || salarieId === null)
            throw new Error("The parameter 'salarieId' must be defined.");
        url_ = url_.replace("{salarieId}", encodeURIComponent("" + salarieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSalarie(_response);
        });
    }

    protected processDeleteSalarie(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDossier(dossierId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDossier(_response);
        });
    }

    protected processDeleteDossier(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMasseSalariale(dossierId: string, cancelToken?: CancelToken | undefined): Promise<MasseSalarialeDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/masseSalariale";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMasseSalariale(_response);
        });
    }

    protected processGetMasseSalariale(response: AxiosResponse): Promise<MasseSalarialeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<MasseSalarialeDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasseSalarialeDto>(<any>null);
    }

    /**
     * @return Success
     */
    soumettreDossier(dossierId: string, cancelToken?: CancelToken | undefined): Promise<EtapeCreationDossier> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/soumettreDossier";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoumettreDossier(_response);
        });
    }

    protected processSoumettreDossier(response: AxiosResponse): Promise<EtapeCreationDossier> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EtapeCreationDossier>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EtapeCreationDossier>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTrajet(dossierId: string, body: CreateOrUpdateTrajetDto | undefined, cancelToken?: CancelToken | undefined): Promise<TrajetDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajet";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTrajet(_response);
        });
    }

    protected processCreateTrajet(response: AxiosResponse): Promise<TrajetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<TrajetDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrajetDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteTrajet(trajetId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{trajetId}/trajet";
        if (trajetId === undefined || trajetId === null)
            throw new Error("The parameter 'trajetId' must be defined.");
        url_ = url_.replace("{trajetId}", encodeURIComponent("" + trajetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTrajet(_response);
        });
    }

    protected processDeleteTrajet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrajet(trajetId: string, body: CreateOrUpdateTrajetDto | undefined, cancelToken?: CancelToken | undefined): Promise<TrajetDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{trajetId}/trajet";
        if (trajetId === undefined || trajetId === null)
            throw new Error("The parameter 'trajetId' must be defined.");
        url_ = url_.replace("{trajetId}", encodeURIComponent("" + trajetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrajet(_response);
        });
    }

    protected processUpdateTrajet(response: AxiosResponse): Promise<TrajetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<TrajetDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrajetDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param disablePagination (optional) 
     * @param versementId (optional) 
     * @return Success
     */
    getTrajets(dossierId: string, filters: string | undefined, sorts: string | undefined, page: number | undefined, pageSize: number | undefined, disablePagination: boolean | undefined, versementId: string | undefined, cancelToken?: CancelToken | undefined): Promise<TrajetViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajets?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        if (versementId === null)
            throw new Error("The parameter 'versementId' cannot be null.");
        else if (versementId !== undefined)
            url_ += "versementId=" + encodeURIComponent("" + versementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrajets(_response);
        });
    }

    protected processGetTrajets(response: AxiosResponse): Promise<TrajetViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<TrajetViewModelDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrajetViewModelDto>(<any>null);
    }

    /**
     * @param versementId (optional) 
     * @param document_Id (optional) 
     * @param document_TypeId (optional) 
     * @param document_PartName (optional) 
     * @param document_ExtraInfos (optional) 
     * @param document_FileName (optional) 
     * @param document_ContentType (optional) 
     * @param document_Content_CanRead (optional) 
     * @param document_Content_CanWrite (optional) 
     * @param document_Content_CanSeek (optional) 
     * @param document_Content_CanTimeout (optional) 
     * @param document_Content_Length (optional) 
     * @param document_Content_Position (optional) 
     * @param document_Content_ReadTimeout (optional) 
     * @param document_Content_WriteTimeout (optional) 
     * @param documents (optional) 
     * @return Success
     */
    validateTrajets(dossierId: string, versementId: string | undefined, document_Id: string | undefined, document_TypeId: string | undefined, document_PartName: string | undefined, document_ExtraInfos: { [key: string]: any; } | undefined, document_FileName: string | undefined, document_ContentType: string | undefined, document_Content_CanRead: boolean | undefined, document_Content_CanWrite: boolean | undefined, document_Content_CanSeek: boolean | undefined, document_Content_CanTimeout: boolean | undefined, document_Content_Length: number | undefined, document_Content_Position: number | undefined, document_Content_ReadTimeout: number | undefined, document_Content_WriteTimeout: number | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<TrajetValidationDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajets/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (versementId === null || versementId === undefined)
            throw new Error("The parameter 'versementId' cannot be null.");
        else
            content_.append("VersementId", versementId.toString());
        if (document_Id === null || document_Id === undefined)
            throw new Error("The parameter 'document_Id' cannot be null.");
        else
            content_.append("Document.Id", document_Id.toString());
        if (document_TypeId === null || document_TypeId === undefined)
            throw new Error("The parameter 'document_TypeId' cannot be null.");
        else
            content_.append("Document.TypeId", document_TypeId.toString());
        if (document_PartName === null || document_PartName === undefined)
            throw new Error("The parameter 'document_PartName' cannot be null.");
        else
            content_.append("Document.PartName", document_PartName.toString());
        if (document_ExtraInfos === null || document_ExtraInfos === undefined)
            throw new Error("The parameter 'document_ExtraInfos' cannot be null.");
        else
            content_.append("Document.ExtraInfos", JSON.stringify(document_ExtraInfos));
        if (document_FileName === null || document_FileName === undefined)
            throw new Error("The parameter 'document_FileName' cannot be null.");
        else
            content_.append("Document.FileName", document_FileName.toString());
        if (document_ContentType === null || document_ContentType === undefined)
            throw new Error("The parameter 'document_ContentType' cannot be null.");
        else
            content_.append("Document.ContentType", document_ContentType.toString());
        if (document_Content_CanRead === null || document_Content_CanRead === undefined)
            throw new Error("The parameter 'document_Content_CanRead' cannot be null.");
        else
            content_.append("Document.Content.CanRead", document_Content_CanRead.toString());
        if (document_Content_CanWrite === null || document_Content_CanWrite === undefined)
            throw new Error("The parameter 'document_Content_CanWrite' cannot be null.");
        else
            content_.append("Document.Content.CanWrite", document_Content_CanWrite.toString());
        if (document_Content_CanSeek === null || document_Content_CanSeek === undefined)
            throw new Error("The parameter 'document_Content_CanSeek' cannot be null.");
        else
            content_.append("Document.Content.CanSeek", document_Content_CanSeek.toString());
        if (document_Content_CanTimeout === null || document_Content_CanTimeout === undefined)
            throw new Error("The parameter 'document_Content_CanTimeout' cannot be null.");
        else
            content_.append("Document.Content.CanTimeout", document_Content_CanTimeout.toString());
        if (document_Content_Length === null || document_Content_Length === undefined)
            throw new Error("The parameter 'document_Content_Length' cannot be null.");
        else
            content_.append("Document.Content.Length", document_Content_Length.toString());
        if (document_Content_Position === null || document_Content_Position === undefined)
            throw new Error("The parameter 'document_Content_Position' cannot be null.");
        else
            content_.append("Document.Content.Position", document_Content_Position.toString());
        if (document_Content_ReadTimeout === null || document_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'document_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Document.Content.ReadTimeout", document_Content_ReadTimeout.toString());
        if (document_Content_WriteTimeout === null || document_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'document_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Document.Content.WriteTimeout", document_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTrajets(_response);
        });
    }

    protected processValidateTrajets(response: AxiosResponse): Promise<TrajetValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<TrajetValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrajetValidationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEnseignantsViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DossierEnseignantsViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignants/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnseignantsViewModel(_response);
        });
    }

    protected processGetEnseignantsViewModel(response: AxiosResponse): Promise<DossierEnseignantsViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierEnseignantsViewModelDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierEnseignantsViewModelDto>(<any>null);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getEnseignants(dossierId: string, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken | undefined): Promise<EnseignantDtoPage> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignants?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnseignants(_response);
        });
    }

    protected processGetEnseignants(response: AxiosResponse): Promise<EnseignantDtoPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EnseignantDtoPage>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantDtoPage>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param disablePagination (optional) 
     * @return Success
     */
    getArtistes(dossierId: string, filters: string | undefined, sorts: string | undefined, page: number | undefined, pageSize: number | undefined, disablePagination: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<ArtisteLightDtoSortedFilteredPage> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArtistes(_response);
        });
    }

    protected processGetArtistes(response: AxiosResponse): Promise<ArtisteLightDtoSortedFilteredPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ArtisteLightDtoSortedFilteredPage>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArtisteLightDtoSortedFilteredPage>(<any>null);
    }

    /**
     * @return Success
     */
    getArtistesViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DossierArtistesViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArtistesViewModel(_response);
        });
    }

    protected processGetArtistesViewModel(response: AxiosResponse): Promise<DossierArtistesViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierArtistesViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierArtistesViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInfosProjetViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DossierInfosProjetViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/informationsProjet";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfosProjetViewModel(_response);
        });
    }

    protected processGetInfosProjetViewModel(response: AxiosResponse): Promise<DossierInfosProjetViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierInfosProjetViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierInfosProjetViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDescriptionProjetViewModel(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DescriptionProjetViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/description-projet/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDescriptionProjetViewModel(_response);
        });
    }

    protected processGetDescriptionProjetViewModel(response: AxiosResponse): Promise<DescriptionProjetViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DescriptionProjetViewModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DescriptionProjetViewModelDto>(<any>null);
    }
}

export class MessageAlerteClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getMessageAlerte(cancelToken?: CancelToken | undefined): Promise<MessageAlerteDto> {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/message";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageAlerte(_response);
        });
    }

    protected processGetMessageAlerte(response: AxiosResponse): Promise<MessageAlerteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<MessageAlerteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageAlerteDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMessageAlerte(cancelToken?: CancelToken | undefined): Promise<MessageAlerteDto[]> {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllMessageAlerte(_response);
        });
    }

    protected processGetAllMessageAlerte(response: AxiosResponse): Promise<MessageAlerteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<MessageAlerteDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageAlerteDto[]>(<any>null);
    }
}

export class MessagerieClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getMessagerie(cancelToken?: CancelToken | undefined): Promise<MessagerieDto> {
        let url_ = this.baseUrl + "/api/v1/Messagerie";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessagerie(_response);
        });
    }

    protected processGetMessagerie(response: AxiosResponse): Promise<MessagerieDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<MessagerieDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessagerieDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMessageDiscussion(discussionId: string, body: CreateMessageDto | undefined, cancelToken?: CancelToken | undefined): Promise<DiscussionMessageDto> {
        let url_ = this.baseUrl + "/api/v1/Messagerie/{discussionId}/message";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMessageDiscussion(_response);
        });
    }

    protected processCreateMessageDiscussion(response: AxiosResponse): Promise<DiscussionMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<DiscussionMessageDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscussionMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    setDiscussionLu(discussionId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Messagerie/{discussionId}/lu";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDiscussionLu(_response);
        });
    }

    protected processSetDiscussionLu(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class NotificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getNotifications(cancelToken?: CancelToken | undefined): Promise<NotificationsDto> {
        let url_ = this.baseUrl + "/api/v1/Notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<NotificationsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<NotificationsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationsDto>(<any>null);
    }
}

export class PageVitrineClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getPagesVitrine(cancelToken?: CancelToken | undefined): Promise<PageVitrineDto[]> {
        let url_ = this.baseUrl + "/api/v1/PageVitrine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagesVitrine(_response);
        });
    }

    protected processGetPagesVitrine(response: AxiosResponse): Promise<PageVitrineDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<PageVitrineDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageVitrineDto[]>(<any>null);
    }
}

export class PaysClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getPays(cancelToken?: CancelToken | undefined): Promise<PaysDto[]> {
        let url_ = this.baseUrl + "/api/v1/Pays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPays(_response);
        });
    }

    protected processGetPays(response: AxiosResponse): Promise<PaysDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<PaysDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaysDto[]>(<any>null);
    }
}

export class StructureClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param json (optional) 
     * @param document1 (optional) 
     * @param document2 (optional) 
     * @param documentN (optional) 
     * @return Success
     */
    createStructure(json: CreateStructureDto | undefined, document1: FileParameter | undefined, document2: FileParameter | undefined, documentN: FileParameter | undefined, cancelToken?: CancelToken | undefined): Promise<StructureDto> {
        let url_ = this.baseUrl + "/api/v1/Structure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (json === null || json === undefined)
            throw new Error("The parameter 'json' cannot be null.");
        else
            content_.append("json", JSON.stringify(json));
        if (document1 === null || document1 === undefined)
            throw new Error("The parameter 'document1' cannot be null.");
        else
            content_.append("document1", document1.data, document1.fileName ? document1.fileName : "document1");
        if (document2 === null || document2 === undefined)
            throw new Error("The parameter 'document2' cannot be null.");
        else
            content_.append("document2", document2.data, document2.fileName ? document2.fileName : "document2");
        if (documentN === null || documentN === undefined)
            throw new Error("The parameter 'documentN' cannot be null.");
        else
            content_.append("documentN", documentN.data, documentN.fileName ? documentN.fileName : "documentN");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStructure(_response);
        });
    }

    protected processCreateStructure(response: AxiosResponse): Promise<StructureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<StructureDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StructureDto>(<any>null);
    }

    /**
     * @param structureId (optional) 
     * @return Success
     */
    getStructureInfoFromSiret(siret: string, structureId: number | undefined, cancelToken?: CancelToken | undefined): Promise<StructureSireneInfoDto> {
        let url_ = this.baseUrl + "/api/v1/Structure/siret/{siret}?";
        if (siret === undefined || siret === null)
            throw new Error("The parameter 'siret' must be defined.");
        url_ = url_.replace("{siret}", encodeURIComponent("" + siret));
        if (structureId === null)
            throw new Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureInfoFromSiret(_response);
        });
    }

    protected processGetStructureInfoFromSiret(response: AxiosResponse): Promise<StructureSireneInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<StructureSireneInfoDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StructureSireneInfoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFormesJuridiques(cancelToken?: CancelToken | undefined): Promise<FormeJuridiqueDto[]> {
        let url_ = this.baseUrl + "/api/v1/Structure/formeJuridique";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormesJuridiques(_response);
        });
    }

    protected processGetFormesJuridiques(response: AxiosResponse): Promise<FormeJuridiqueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<FormeJuridiqueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FormeJuridiqueDto[]>(<any>null);
    }

    /**
     * @param codeAPE (optional) 
     * @param nomenclatureAPE (optional) 
     * @return Success
     */
    getRequiredTypesDeDocument(formeJuridiqueId: string, codeAPE: string | undefined, nomenclatureAPE: string | undefined, cancelToken?: CancelToken | undefined): Promise<TypeDeDocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Structure/formeJuridique/{formeJuridiqueId}/requiredTypeDeDocument?";
        if (formeJuridiqueId === undefined || formeJuridiqueId === null)
            throw new Error("The parameter 'formeJuridiqueId' must be defined.");
        url_ = url_.replace("{formeJuridiqueId}", encodeURIComponent("" + formeJuridiqueId));
        if (codeAPE === null)
            throw new Error("The parameter 'codeAPE' cannot be null.");
        else if (codeAPE !== undefined)
            url_ += "codeAPE=" + encodeURIComponent("" + codeAPE) + "&";
        if (nomenclatureAPE === null)
            throw new Error("The parameter 'nomenclatureAPE' cannot be null.");
        else if (nomenclatureAPE !== undefined)
            url_ += "nomenclatureAPE=" + encodeURIComponent("" + nomenclatureAPE) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequiredTypesDeDocument(_response);
        });
    }

    protected processGetRequiredTypesDeDocument(response: AxiosResponse): Promise<TypeDeDocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<TypeDeDocumentDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypeDeDocumentDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStructureTypesDeDocument(cancelToken?: CancelToken | undefined): Promise<TypeDeDocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Structure/requiredTypeDeDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureTypesDeDocument(_response);
        });
    }

    protected processGetStructureTypesDeDocument(response: AxiosResponse): Promise<TypeDeDocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<TypeDeDocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TypeDeDocumentDto[]>(<any>null);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    resendValidationEmail(structureId: string, email: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/resendValidationEmail?";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendValidationEmail(_response);
        });
    }

    protected processResendValidationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDocuments(cancelToken?: CancelToken | undefined): Promise<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Structure/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<DocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStructureValidationContacts(cancelToken?: CancelToken | undefined): Promise<StructureValidationContactsDto> {
        let url_ = this.baseUrl + "/api/v1/Structure/validation/contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureValidationContacts(_response);
        });
    }

    protected processGetStructureValidationContacts(response: AxiosResponse): Promise<StructureValidationContactsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<StructureValidationContactsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StructureValidationContactsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStructureValidationContacts(body: UpdateStructureValidationContactsDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/validation/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureValidationContacts(_response);
        });
    }

    protected processUpdateStructureValidationContacts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param iban (optional) 
     * @param bic (optional) 
     * @param banque (optional) 
     * @param adresse_Line1 (optional) 
     * @param adresse_Line2 (optional) 
     * @param adresse_CodePostal (optional) 
     * @param adresse_Ville (optional) 
     * @param rIB_Id (optional) 
     * @param rIB_TypeId (optional) 
     * @param rIB_PartName (optional) 
     * @param rIB_ExtraInfos (optional) 
     * @param rIB_FileName (optional) 
     * @param rIB_ContentType (optional) 
     * @param rIB_Content_CanRead (optional) 
     * @param rIB_Content_CanWrite (optional) 
     * @param rIB_Content_CanSeek (optional) 
     * @param rIB_Content_CanTimeout (optional) 
     * @param rIB_Content_Length (optional) 
     * @param rIB_Content_Position (optional) 
     * @param rIB_Content_ReadTimeout (optional) 
     * @param rIB_Content_WriteTimeout (optional) 
     * @param files (optional) 
     * @return Success
     */
    createOrUpdateDonneesBancaires(iban: string | undefined, bic: string | undefined, banque: string | undefined, adresse_Line1: string | undefined, adresse_Line2: string | undefined, adresse_CodePostal: string | undefined, adresse_Ville: string | undefined, rIB_Id: string | undefined, rIB_TypeId: string | undefined, rIB_PartName: string | undefined, rIB_ExtraInfos: { [key: string]: any; } | undefined, rIB_FileName: string | undefined, rIB_ContentType: string | undefined, rIB_Content_CanRead: boolean | undefined, rIB_Content_CanWrite: boolean | undefined, rIB_Content_CanSeek: boolean | undefined, rIB_Content_CanTimeout: boolean | undefined, rIB_Content_Length: number | undefined, rIB_Content_Position: number | undefined, rIB_Content_ReadTimeout: number | undefined, rIB_Content_WriteTimeout: number | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/donneesBancaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (iban === null || iban === undefined)
            throw new Error("The parameter 'iban' cannot be null.");
        else
            content_.append("Iban", iban.toString());
        if (bic === null || bic === undefined)
            throw new Error("The parameter 'bic' cannot be null.");
        else
            content_.append("Bic", bic.toString());
        if (banque === null || banque === undefined)
            throw new Error("The parameter 'banque' cannot be null.");
        else
            content_.append("Banque", banque.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (rIB_Id === null || rIB_Id === undefined)
            throw new Error("The parameter 'rIB_Id' cannot be null.");
        else
            content_.append("RIB.Id", rIB_Id.toString());
        if (rIB_TypeId === null || rIB_TypeId === undefined)
            throw new Error("The parameter 'rIB_TypeId' cannot be null.");
        else
            content_.append("RIB.TypeId", rIB_TypeId.toString());
        if (rIB_PartName === null || rIB_PartName === undefined)
            throw new Error("The parameter 'rIB_PartName' cannot be null.");
        else
            content_.append("RIB.PartName", rIB_PartName.toString());
        if (rIB_ExtraInfos === null || rIB_ExtraInfos === undefined)
            throw new Error("The parameter 'rIB_ExtraInfos' cannot be null.");
        else
            content_.append("RIB.ExtraInfos", JSON.stringify(rIB_ExtraInfos));
        if (rIB_FileName === null || rIB_FileName === undefined)
            throw new Error("The parameter 'rIB_FileName' cannot be null.");
        else
            content_.append("RIB.FileName", rIB_FileName.toString());
        if (rIB_ContentType === null || rIB_ContentType === undefined)
            throw new Error("The parameter 'rIB_ContentType' cannot be null.");
        else
            content_.append("RIB.ContentType", rIB_ContentType.toString());
        if (rIB_Content_CanRead === null || rIB_Content_CanRead === undefined)
            throw new Error("The parameter 'rIB_Content_CanRead' cannot be null.");
        else
            content_.append("RIB.Content.CanRead", rIB_Content_CanRead.toString());
        if (rIB_Content_CanWrite === null || rIB_Content_CanWrite === undefined)
            throw new Error("The parameter 'rIB_Content_CanWrite' cannot be null.");
        else
            content_.append("RIB.Content.CanWrite", rIB_Content_CanWrite.toString());
        if (rIB_Content_CanSeek === null || rIB_Content_CanSeek === undefined)
            throw new Error("The parameter 'rIB_Content_CanSeek' cannot be null.");
        else
            content_.append("RIB.Content.CanSeek", rIB_Content_CanSeek.toString());
        if (rIB_Content_CanTimeout === null || rIB_Content_CanTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_CanTimeout' cannot be null.");
        else
            content_.append("RIB.Content.CanTimeout", rIB_Content_CanTimeout.toString());
        if (rIB_Content_Length === null || rIB_Content_Length === undefined)
            throw new Error("The parameter 'rIB_Content_Length' cannot be null.");
        else
            content_.append("RIB.Content.Length", rIB_Content_Length.toString());
        if (rIB_Content_Position === null || rIB_Content_Position === undefined)
            throw new Error("The parameter 'rIB_Content_Position' cannot be null.");
        else
            content_.append("RIB.Content.Position", rIB_Content_Position.toString());
        if (rIB_Content_ReadTimeout === null || rIB_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_ReadTimeout' cannot be null.");
        else
            content_.append("RIB.Content.ReadTimeout", rIB_Content_ReadTimeout.toString());
        if (rIB_Content_WriteTimeout === null || rIB_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_WriteTimeout' cannot be null.");
        else
            content_.append("RIB.Content.WriteTimeout", rIB_Content_WriteTimeout.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateDonneesBancaires(_response);
        });
    }

    protected processCreateOrUpdateDonneesBancaires(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStructureJuridique(body: UpdateStructureJuridiqueDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Structure/structureJuridique";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureJuridique(_response);
        });
    }

    protected processUpdateStructureJuridique(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStructureContact(body: UpdateStructureContactDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureContact(_response);
        });
    }

    protected processUpdateStructureContact(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStructureAdresse(body: UpdateStructureAdresseDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/adresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureAdresse(_response);
        });
    }

    protected processUpdateStructureAdresse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getStructureCategoriesDossier(cancelToken?: CancelToken | undefined): Promise<CategorieDossierDto[]> {
        let url_ = this.baseUrl + "/api/v1/Structure/categoriesDossier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureCategoriesDossier(_response);
        });
    }

    protected processGetStructureCategoriesDossier(response: AxiosResponse): Promise<CategorieDossierDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<CategorieDossierDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategorieDossierDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStructureCorrespondantAdministratif(cancelToken?: CancelToken | undefined): Promise<ContactDto> {
        let url_ = this.baseUrl + "/api/v1/Structure/correspondantAdministratif";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureCorrespondantAdministratif(_response);
        });
    }

    protected processGetStructureCorrespondantAdministratif(response: AxiosResponse): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<ContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDto>(<any>null);
    }

    /**
     * @return Success
     */
    getStructureDetails(cancelToken?: CancelToken | undefined): Promise<StructureDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/Structure/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStructureDetails(_response);
        });
    }

    protected processGetStructureDetails(response: AxiosResponse): Promise<StructureDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<StructureDetailsDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StructureDetailsDto>(<any>null);
    }

    /**
     * @param documents (optional) 
     * @param files (optional) 
     * @return Success
     */
    updateStructureDocuments(documents: DocumentUploadInfoDto[] | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/structureDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureDocuments(_response);
        });
    }

    protected processUpdateStructureDocuments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStructureInformations(body: UpdateStructureInformationsDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Structure/informations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStructureInformations(_response);
        });
    }

    protected processUpdateStructureInformations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TestClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    deleteBudget(dossierId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Test/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBudget(_response);
        });
    }

    protected processDeleteBudget(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserEmail(body: ChangeEmailDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/email/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserEmail(_response);
        });
    }

    protected processChangeUserEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMe(cancelToken?: CancelToken | undefined): Promise<FOCurrentUserDto> {
        let url_ = this.baseUrl + "/api/v1/User/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<FOCurrentUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<FOCurrentUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FOCurrentUserDto>(<any>null);
    }
}

export class ValidationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getValidationDescriptors(cancelToken?: CancelToken | undefined): Promise<{ [key: string]: { [key: string]: PropertyValidatorInfo[]; }; }> {
        let url_ = this.baseUrl + "/api/v1/Validation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetValidationDescriptors(_response);
        });
    }

    protected processGetValidationDescriptors(response: AxiosResponse): Promise<{ [key: string]: { [key: string]: PropertyValidatorInfo[]; }; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<{ [key: string]: { [key: string]: PropertyValidatorInfo[]; }; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: { [key: string]: PropertyValidatorInfo[]; }; }>(<any>null);
    }
}

export class VersementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVersement(dossierId: string, body: CreateVersementDto | undefined, cancelToken?: CancelToken | undefined): Promise<VersementDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVersement(_response);
        });
    }

    protected processCreateVersement(response: AxiosResponse): Promise<VersementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<VersementDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersementDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param disablePagination (optional) 
     * @return Success
     */
    getVersements(dossierId: string, filters: string | undefined, sorts: string | undefined, page: number | undefined, pageSize: number | undefined, disablePagination: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<DossierVersementsViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versements?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersements(_response);
        });
    }

    protected processGetVersements(response: AxiosResponse): Promise<DossierVersementsViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DossierVersementsViewModelDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DossierVersementsViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEtapesDemandeVersement(categorieId: string, cancelToken?: CancelToken | undefined): Promise<EtapeDemandeVersement[]> {
        let url_ = this.baseUrl + "/api/v1/Versement/categorie/{categorieId}/etapes";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEtapesDemandeVersement(_response);
        });
    }

    protected processGetEtapesDemandeVersement(response: AxiosResponse): Promise<EtapeDemandeVersement[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<EtapeDemandeVersement[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EtapeDemandeVersement[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteVersement(versementId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/delete";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVersement(_response);
        });
    }

    protected processDeleteVersement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDemandeVersementDetails(versementId: string, cancelToken?: CancelToken | undefined): Promise<DemandeVersementDetailDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/details";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDemandeVersementDetails(_response);
        });
    }

    protected processGetDemandeVersementDetails(response: AxiosResponse): Promise<DemandeVersementDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DemandeVersementDetailDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeVersementDetailDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDemandeVersementInfos(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DemandeVersementInfosDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/infos";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDemandeVersementInfos(_response);
        });
    }

    protected processGetDemandeVersementInfos(response: AxiosResponse): Promise<DemandeVersementInfosDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DemandeVersementInfosDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeVersementInfosDto>(<any>null);
    }

    /**
     * @param hasSendDocPromoImage (optional) 
     * @return Success
     */
    updateHasSendDocPromoImage(dossierId: string,isDeleted: string, hasSendDocPromoImage: boolean | undefined, 
        file: any,
        cancelToken?: CancelToken | undefined): 
        Promise<any> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/{isDeleted}/versement/infos/promoimage?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace("{isDeleted}", encodeURIComponent("" + isDeleted));
        if (hasSendDocPromoImage === null)
            throw new Error("The parameter 'hasSendDocPromoImage' cannot be null.");
        else if (hasSendDocPromoImage !== undefined)
            url_ += "hasSendDocPromoImage=" + encodeURIComponent("" + hasSendDocPromoImage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        // const content_ = new FormData();
        // if (docAPI === null || docAPI === undefined)
        //     throw new Error("The parameter 'piecesJointes' cannot be null.");
        // else
        // docAPI.forEach(item_ => content_.append("PiecesJointes", item_.toString()));
        // if (documents === null || documents === undefined)
        //     throw new Error("The parameter 'documents' cannot be null.");
        // else
        //     documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

            const formData = new FormData();
            formData.append('file', file);
        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                //'Content-Type': 'multipart/form-data',
                // "Accept": "application/json"
            },
            data: formData,
            cancelToken
        };

        return this.instance.post(url_, formData, options_).then((_response: AxiosResponse) => {
            return this.processUpdateHasSendDocPromoImage(_response);
        });

        // return this.instance.request(options_).catch((_error: any) => {
        //     if (isAxiosError(_error) && _error.response) {
        //         return _error.response;
        //     } else {
        //         throw _error;
        //     }
        // }).then((_response: AxiosResponse) => {
        //     return this.processUpdateHasSendDocPromoImage(_response);
        // });
    }

    protected processUpdateHasSendDocPromoImage(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    getDemandeVersementLieuxDates(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DemandeVersementLieuDateDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDemandeVersementLieuxDates(_response);
        });
    }

    protected processGetDemandeVersementLieuxDates(response: AxiosResponse): Promise<DemandeVersementLieuDateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DemandeVersementLieuDateDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeVersementLieuDateDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrestationOnDemandeVersement(dossierId: string, body: CreateLieuDto | undefined, cancelToken?: CancelToken | undefined): Promise<LieuDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/create";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePrestationOnDemandeVersement(_response);
        });
    }

    protected processCreatePrestationOnDemandeVersement(response: AxiosResponse): Promise<LieuDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<LieuDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePrestationOnDemandeVersement(dossierId: string, lieuId: string, body: UpdateLieuDto | undefined, cancelToken?: CancelToken | undefined): Promise<LieuDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/{lieuId}/update";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (lieuId === undefined || lieuId === null)
            throw new Error("The parameter 'lieuId' must be defined.");
        url_ = url_.replace("{lieuId}", encodeURIComponent("" + lieuId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePrestationOnDemandeVersement(_response);
        });
    }

    protected processUpdatePrestationOnDemandeVersement(response: AxiosResponse): Promise<LieuDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<LieuDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LieuDto>(<any>null);
    }

    /**
     * @return Success
     */
    deletePrestationOnDemandeVersement(dossierId: string, lieuId: string, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/{lieuId}/delete";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (lieuId === undefined || lieuId === null)
            throw new Error("The parameter 'lieuId' must be defined.");
        url_ = url_.replace("{lieuId}", encodeURIComponent("" + lieuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePrestationOnDemandeVersement(_response);
        });
    }

    protected processDeletePrestationOnDemandeVersement(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    getContratsCachetsOnDemandeVersement(versementId: string, cancelToken?: CancelToken | undefined): Promise<DemandeVersementContratCachetDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/contratscachets";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContratsCachetsOnDemandeVersement(_response);
        });
    }

    protected processGetContratsCachetsOnDemandeVersement(response: AxiosResponse): Promise<DemandeVersementContratCachetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DemandeVersementContratCachetDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeVersementContratCachetDto>(<any>null);
    }

    /**
     * @param depensesSpecifiques (optional) 
     * @param autresDepenses (optional) 
     * @param documents (optional) 
     * @return Success
     */
    createOrUpdateDepenses(dossierId: string, depensesSpecifiques: UpdateDepenseDto[] | undefined, autresDepenses: UpdateDepenseDto[] | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/depenses";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (depensesSpecifiques === null || depensesSpecifiques === undefined)
            throw new Error("The parameter 'depensesSpecifiques' cannot be null.");
        else
            depensesSpecifiques.forEach(item_ => content_.append("DepensesSpecifiques", item_.toString()));
        if (autresDepenses === null || autresDepenses === undefined)
            throw new Error("The parameter 'autresDepenses' cannot be null.");
        else
            autresDepenses.forEach(item_ => content_.append("AutresDepenses", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateDepenses(_response);
        });
    }

    protected processCreateOrUpdateDepenses(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<Unit>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVersementCommentaire(versementId: string, body: UpdateVersementCommentaireDto | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/commentaire";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVersementCommentaire(_response);
        });
    }

    protected processUpdateVersementCommentaire(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @param sorts (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param disablePagination (optional) 
     * @return Success
     */
    getVersementArtistes(versementId: string, filters: string | undefined, sorts: string | undefined, page: number | undefined, pageSize: number | undefined, disablePagination: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<VersementArtisteLightDtoSortedFilteredPage> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/artistes?";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersementArtistes(_response);
        });
    }

    protected processGetVersementArtistes(response: AxiosResponse): Promise<VersementArtisteLightDtoSortedFilteredPage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<VersementArtisteLightDtoSortedFilteredPage>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersementArtisteLightDtoSortedFilteredPage>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVersementArtiste(versementId: string, body: CreateOrUpdateVersementArtisteDto | undefined, cancelToken?: CancelToken | undefined): Promise<VersementArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementId}";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVersementArtiste(_response);
        });
    }

    protected processCreateVersementArtiste(response: AxiosResponse): Promise<VersementArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<VersementArtisteDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersementArtisteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVersementArtiste(versementArtisteId: string, body: CreateOrUpdateVersementArtisteDto | undefined, cancelToken?: CancelToken | undefined): Promise<VersementArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVersementArtiste(_response);
        });
    }

    protected processUpdateVersementArtiste(response: AxiosResponse): Promise<VersementArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<VersementArtisteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersementArtisteDto>(<any>null);
    }

    /**
     * @return Success
     */
    getVersementArtiste(versementArtisteId: string, cancelToken?: CancelToken | undefined): Promise<VersementArtisteDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersementArtiste(_response);
        });
    }

    protected processGetVersementArtiste(response: AxiosResponse): Promise<VersementArtisteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<VersementArtisteDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VersementArtisteDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteVersementArtiste(versementArtisteId: string, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVersementArtiste(_response);
        });
    }

    protected processDeleteVersementArtiste(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param ville (optional) 
     * @param disciplines (optional) 
     * @param otherDiscipline (optional) 
     * @param instrumentId (optional) 
     * @param qualification (optional) 
     * @param typeContrat (optional) 
     * @param statut (optional) 
     * @param remunerationBruteAnnuelle (optional) 
     * @param montantChargesPatronales (optional) 
     * @param tarifHoraireBrut (optional) 
     * @param remunerationPremierTrimestre (optional) 
     * @param contratEngagement_Id (optional) 
     * @param contratEngagement_TypeId (optional) 
     * @param contratEngagement_PartName (optional) 
     * @param contratEngagement_ExtraInfos (optional) 
     * @param contratEngagement_FileName (optional) 
     * @param contratEngagement_ContentType (optional) 
     * @param contratEngagement_Content_CanRead (optional) 
     * @param contratEngagement_Content_CanWrite (optional) 
     * @param contratEngagement_Content_CanSeek (optional) 
     * @param contratEngagement_Content_CanTimeout (optional) 
     * @param contratEngagement_Content_Length (optional) 
     * @param contratEngagement_Content_Position (optional) 
     * @param contratEngagement_Content_ReadTimeout (optional) 
     * @param contratEngagement_Content_WriteTimeout (optional) 
     * @param justificatifRemuneration_Id (optional) 
     * @param justificatifRemuneration_TypeId (optional) 
     * @param justificatifRemuneration_PartName (optional) 
     * @param justificatifRemuneration_ExtraInfos (optional) 
     * @param justificatifRemuneration_FileName (optional) 
     * @param justificatifRemuneration_ContentType (optional) 
     * @param justificatifRemuneration_Content_CanRead (optional) 
     * @param justificatifRemuneration_Content_CanWrite (optional) 
     * @param justificatifRemuneration_Content_CanSeek (optional) 
     * @param justificatifRemuneration_Content_CanTimeout (optional) 
     * @param justificatifRemuneration_Content_Length (optional) 
     * @param justificatifRemuneration_Content_Position (optional) 
     * @param justificatifRemuneration_Content_ReadTimeout (optional) 
     * @param justificatifRemuneration_Content_WriteTimeout (optional) 
     * @param documents (optional) 
     * @return Success
     */
    createEnseignantOnDemandeVersement(dossierId: string, nom: string | undefined, prenom: string | undefined, ville: string | undefined, disciplines: string[] | undefined, otherDiscipline: string | undefined, instrumentId: string | undefined, qualification: QualificationEnseignant | undefined, typeContrat: TypeContrat | undefined, statut: StatutEnseignant | undefined, remunerationBruteAnnuelle: number | undefined, montantChargesPatronales: number | undefined, tarifHoraireBrut: number | undefined, remunerationPremierTrimestre: number | undefined, contratEngagement_Id: string | undefined, contratEngagement_TypeId: string | undefined, contratEngagement_PartName: string | undefined, contratEngagement_ExtraInfos: { [key: string]: any; } | undefined, contratEngagement_FileName: string | undefined, contratEngagement_ContentType: string | undefined, contratEngagement_Content_CanRead: boolean | undefined, contratEngagement_Content_CanWrite: boolean | undefined, contratEngagement_Content_CanSeek: boolean | undefined, contratEngagement_Content_CanTimeout: boolean | undefined, contratEngagement_Content_Length: number | undefined, contratEngagement_Content_Position: number | undefined, contratEngagement_Content_ReadTimeout: number | undefined, contratEngagement_Content_WriteTimeout: number | undefined, justificatifRemuneration_Id: string | undefined, justificatifRemuneration_TypeId: string | undefined, justificatifRemuneration_PartName: string | undefined, justificatifRemuneration_ExtraInfos: { [key: string]: any; } | undefined, justificatifRemuneration_FileName: string | undefined, justificatifRemuneration_ContentType: string | undefined, justificatifRemuneration_Content_CanRead: boolean | undefined, justificatifRemuneration_Content_CanWrite: boolean | undefined, justificatifRemuneration_Content_CanSeek: boolean | undefined, justificatifRemuneration_Content_CanTimeout: boolean | undefined, justificatifRemuneration_Content_Length: number | undefined, justificatifRemuneration_Content_Position: number | undefined, justificatifRemuneration_Content_ReadTimeout: number | undefined, justificatifRemuneration_Content_WriteTimeout: number | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<EnseignantDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/enseignant/create";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEnseignantOnDemandeVersement(_response);
        });
    }

    protected processCreateEnseignantOnDemandeVersement(response: AxiosResponse): Promise<EnseignantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<EnseignantDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantDto>(<any>null);
    }

    /**
     * @param nom (optional) 
     * @param prenom (optional) 
     * @param ville (optional) 
     * @param disciplines (optional) 
     * @param otherDiscipline (optional) 
     * @param instrumentId (optional) 
     * @param qualification (optional) 
     * @param typeContrat (optional) 
     * @param statut (optional) 
     * @param remunerationBruteAnnuelle (optional) 
     * @param montantChargesPatronales (optional) 
     * @param tarifHoraireBrut (optional) 
     * @param remunerationPremierTrimestre (optional) 
     * @param contratEngagement_Id (optional) 
     * @param contratEngagement_TypeId (optional) 
     * @param contratEngagement_PartName (optional) 
     * @param contratEngagement_ExtraInfos (optional) 
     * @param contratEngagement_FileName (optional) 
     * @param contratEngagement_ContentType (optional) 
     * @param contratEngagement_Content_CanRead (optional) 
     * @param contratEngagement_Content_CanWrite (optional) 
     * @param contratEngagement_Content_CanSeek (optional) 
     * @param contratEngagement_Content_CanTimeout (optional) 
     * @param contratEngagement_Content_Length (optional) 
     * @param contratEngagement_Content_Position (optional) 
     * @param contratEngagement_Content_ReadTimeout (optional) 
     * @param contratEngagement_Content_WriteTimeout (optional) 
     * @param justificatifRemuneration_Id (optional) 
     * @param justificatifRemuneration_TypeId (optional) 
     * @param justificatifRemuneration_PartName (optional) 
     * @param justificatifRemuneration_ExtraInfos (optional) 
     * @param justificatifRemuneration_FileName (optional) 
     * @param justificatifRemuneration_ContentType (optional) 
     * @param justificatifRemuneration_Content_CanRead (optional) 
     * @param justificatifRemuneration_Content_CanWrite (optional) 
     * @param justificatifRemuneration_Content_CanSeek (optional) 
     * @param justificatifRemuneration_Content_CanTimeout (optional) 
     * @param justificatifRemuneration_Content_Length (optional) 
     * @param justificatifRemuneration_Content_Position (optional) 
     * @param justificatifRemuneration_Content_ReadTimeout (optional) 
     * @param justificatifRemuneration_Content_WriteTimeout (optional) 
     * @param documents (optional) 
     * @return Success
     */
    updateEnseignantOnDemandeVersement(enseignantId: string, nom: string | undefined, prenom: string | undefined, ville: string | undefined, disciplines: string[] | undefined, otherDiscipline: string | undefined, instrumentId: string | undefined, qualification: QualificationEnseignant | undefined, typeContrat: TypeContrat | undefined, statut: StatutEnseignant | undefined, remunerationBruteAnnuelle: number | undefined, montantChargesPatronales: number | undefined, tarifHoraireBrut: number | undefined, remunerationPremierTrimestre: number | undefined, contratEngagement_Id: string | undefined, contratEngagement_TypeId: string | undefined, contratEngagement_PartName: string | undefined, contratEngagement_ExtraInfos: { [key: string]: any; } | undefined, contratEngagement_FileName: string | undefined, contratEngagement_ContentType: string | undefined, contratEngagement_Content_CanRead: boolean | undefined, contratEngagement_Content_CanWrite: boolean | undefined, contratEngagement_Content_CanSeek: boolean | undefined, contratEngagement_Content_CanTimeout: boolean | undefined, contratEngagement_Content_Length: number | undefined, contratEngagement_Content_Position: number | undefined, contratEngagement_Content_ReadTimeout: number | undefined, contratEngagement_Content_WriteTimeout: number | undefined, justificatifRemuneration_Id: string | undefined, justificatifRemuneration_TypeId: string | undefined, justificatifRemuneration_PartName: string | undefined, justificatifRemuneration_ExtraInfos: { [key: string]: any; } | undefined, justificatifRemuneration_FileName: string | undefined, justificatifRemuneration_ContentType: string | undefined, justificatifRemuneration_Content_CanRead: boolean | undefined, justificatifRemuneration_Content_CanWrite: boolean | undefined, justificatifRemuneration_Content_CanSeek: boolean | undefined, justificatifRemuneration_Content_CanTimeout: boolean | undefined, justificatifRemuneration_Content_Length: number | undefined, justificatifRemuneration_Content_Position: number | undefined, justificatifRemuneration_Content_ReadTimeout: number | undefined, justificatifRemuneration_Content_WriteTimeout: number | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<EnseignantDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/versement/contratscachets/enseignant/{enseignantId}/update";
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnseignantOnDemandeVersement(_response);
        });
    }

    protected processUpdateEnseignantOnDemandeVersement(response: AxiosResponse): Promise<EnseignantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<EnseignantDto>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnseignantDto>(<any>null);
    }

    /**
     * @param versementArtistes (optional) 
     * @param documents (optional) 
     * @return Success
     */
    updateArtisteDocument(versementId: string, versementArtistes: UpdateVersementArtisteDocumentDto[] | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/contratscachets/artiste/document";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (versementArtistes === null || versementArtistes === undefined)
            throw new Error("The parameter 'versementArtistes' cannot be null.");
        else
            versementArtistes.forEach(item_ => content_.append("VersementArtistes", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArtisteDocument(_response);
        });
    }

    protected processUpdateArtisteDocument(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @param enseignants (optional) 
     * @param documents (optional) 
     * @return Success
     */
    updateEnseignantRemuneration(dossierId: string, enseignants: UpdateEnseignantRemunerationDto[] | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/enseignant/remuneration";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enseignants === null || enseignants === undefined)
            throw new Error("The parameter 'enseignants' cannot be null.");
        else
            enseignants.forEach(item_ => content_.append("Enseignants", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnseignantRemuneration(_response);
        });
    }

    protected processUpdateEnseignantRemuneration(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEnseignantOnDemandeVersement(enseignantId: string, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/versement/contratscachets/enseignant/{enseignantId}/delete";
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnseignantOnDemandeVersement(_response);
        });
    }

    protected processDeleteEnseignantOnDemandeVersement(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    getPiecesJointesOnDemandeVersement(versementId: string, cancelToken?: CancelToken | undefined): Promise<DemandeVersementPieceJointeViewModelDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/piecesjointes";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPiecesJointesOnDemandeVersement(_response);
        });
    }

    protected processGetPiecesJointesOnDemandeVersement(response: AxiosResponse): Promise<DemandeVersementPieceJointeViewModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DemandeVersementPieceJointeViewModelDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DemandeVersementPieceJointeViewModelDto>(<any>null);
    }

    /**
     * @return Success
     */
    getInfoBancaireOnDemandeVersement(dossierId: string, cancelToken?: CancelToken | undefined): Promise<DonneesBancairesDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/infobancaire";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfoBancaireOnDemandeVersement(_response);
        });
    }

    protected processGetInfoBancaireOnDemandeVersement(response: AxiosResponse): Promise<DonneesBancairesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<DonneesBancairesDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonneesBancairesDto>(<any>null);
    }

    /**
     * @param piecesJointes (optional) 
     * @param documents (optional) 
     * @return Success
     */
    createOrUpdatePieceJointes(versementId: string, piecesJointes: DocumentUploadInfoDto[] | undefined, documents: FileParameter[] | undefined, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/piecesjointes/update";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (piecesJointes === null || piecesJointes === undefined)
            throw new Error("The parameter 'piecesJointes' cannot be null.");
        else
            piecesJointes.forEach(item_ => content_.append("PiecesJointes", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdatePieceJointes(_response);
        });
    }

    protected processCreateOrUpdatePieceJointes(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve<Unit>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }

    /**
     * @return Success
     */
    getRecapitulatifDemandeVersement(versementId: string, cancelToken?: CancelToken | undefined): Promise<RecapitulatifVersementDto> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/recapitulatif";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecapitulatifDemandeVersement(_response);
        });
    }

    protected processGetRecapitulatifDemandeVersement(response: AxiosResponse): Promise<RecapitulatifVersementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<RecapitulatifVersementDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecapitulatifVersementDto>(<any>null);
    }

    /**
     * @return Success
     */
    soumettreVersement(versementId: string, cancelToken?: CancelToken | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/soumettre";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSoumettreVersement(_response);
        });
    }

    protected processSoumettreVersement(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<Unit>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(<any>null);
    }
}

export interface AdelUserDto {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    estActif?: boolean;
    createdAt?: Date;
    modifiedAt?: Date | undefined;
    dateActivation?: Date | undefined;
    dateDesactivation?: Date | undefined;
}

export interface AdresseDto {
    id?: string;
    line1?: string | undefined;
    line2?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
}

export interface AidesFonctionnementByYearModel {
    anneeScolaireDebut?: number;
    anneeScolaireFin?: number;
    financements?: FinancementLightDto[] | undefined;
}

export interface AnswerChoiceDto {
    id?: string | undefined;
    text?: { [key: string]: string; } | undefined;
    isNone?: boolean;
    isOther?: boolean;
    conditions?: ConditionDto[] | undefined;
    textWithoutTraduction?: string;
}

export enum AnswerType {
    None = "none",
    Text = "text",
    MultilineText = "multilineText",
    Date = "date",
    IntegerNumber = "integerNumber",
    DecimalNumber = "decimalNumber",
    SingleChoiceList = "singleChoiceList",
    MultipleChoiceList = "multipleChoiceList",
    YesNo = "yesNo",
    YesNoDontKnow = "yesNoDontKnow",
    File = "file",
    Url = "url",
    Link = "link",
    Period = "period",
    Html = "html",
    Array = "array",
    Blocking = "blocking",
}

export interface ArtisteDetailsDto {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    dossierId?: string;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    siteInternet?: string | undefined;
    salaireBrut?: number;
    chargePatronales?: number;
    emploi?: Emploi;
    styleMusical?: StyleMusicalDto;
    instrument?: InstrumentDto;
    artistePrincipal?: boolean;
    formation?: string | undefined;
    isGenerationSpedidam?: boolean;
    isAssociated?: boolean;
    isTitulaire?: boolean;
    isEngagementDirect?: boolean;
    montantRepetitions?: number | undefined;
    montantRepresentations?: number | undefined;
    montantEnregistrement?: number | undefined;
    montantConcert?: number | undefined;
    mensualisations?: number | undefined;
    montantCharge?: number | undefined;
}

export interface ArtisteDto {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    siteInternet?: string | undefined;
    salaireBrut?: number;
    chargePatronales?: number;
    dossierId?: string;
    emploi?: Emploi;
    styleMusical?: StyleMusicalDto;
    instrument?: InstrumentDto;
    artistePrincipal?: boolean;
    formation?: string | undefined;
    isGenerationSpedidam?: boolean;
    isAssociated?: boolean;
    isTitulaire?: boolean;
    isEngagementDirect?: boolean;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    cachets?: CachetDto[] | undefined;
    salaires?: SalaireDto[] | undefined;
    contrat?: DocumentWithValidationDto;
    bulletin?: DocumentWithValidationDto;
}

export interface ArtisteLightDto {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    fullName?: string | undefined;
    dossierId?: string;
    emploi?: Emploi;
    artistePrincipal?: boolean;
    isAssociated?: boolean;
    isTitulaire?: boolean;
}

export interface ArtisteLightDtoSortedFilteredPage {
    readonly actualCount?: number;
    readonly items?: ArtisteLightDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
    readonly sortTerms?: SortTerm[] | undefined;
    readonly filterTerms?: FilterTerm[] | undefined;
}

export interface ArtistesValidationDto {
    errors?: ArtistesValidationErrorDto[] | undefined;
}

export interface ArtistesValidationErrorDto {
    hasDateWithoutCachet?: boolean | undefined;
    hasMinimumNbArtisteEngagement?: boolean | undefined;
    nombreLimiteArtisteEngagementDirect?: number | undefined;
    numberOfArtisteMustBeTheSameForEachRepresentationDate?: boolean | undefined;
    emploiComparisonConstraint?: EmploiComparisonConstraintDto;
    shouldHaveLess?: Emploi[] | undefined;
    than?: Emploi[] | undefined;
    minimumEmploiCountConstraint?: MinimumEmploiCountConstraintDto[] | undefined;
    surpassedMensualisationLimit?: number | undefined;
    nombreLimiteArtiste?: number;
    typeCachetRequired?: TypePrestation[] | undefined;
    artisteWithLessDateInDifferentPlaceThan?: number | undefined;
    artisteWithLessDateInDifferentPlaceThanFullName?: string | undefined;
    numberOfAudioArtistMustBeInferiorToVisualArtist?: boolean | undefined;
}

export interface BudgetDto {
    dossierId?: string;
    commentaire?: string | undefined;
    documents?: DocumentWithValidationDto[] | undefined;
    depenses?: DepenseDto[] | undefined;
    financements?: FinancementDto[] | undefined;
}

export interface BudgetViewModelDto {
    montantMax?: number | undefined;
    montantMin?: number | undefined;
    pourcentageAide?: number | undefined;
    hasBalance?: boolean;
    baseCalculSpedidam?: number | undefined;
    montantMaxAide?: number | undefined;
    depenses?: DepenseBlockViewModelDto[] | undefined;
    financements?: FinancementBlockViewModelDto[] | undefined;
}

export interface CachetDto {
    id?: string;
    montantBrut?: number;
    tauxChargesPatronales?: number;
    count?: number;
    dates?: LieuDateDto[] | undefined;
    typePrestation?: TypePrestation;
}

export interface CategorieDossierDto {
    id?: string;
    code?: string | undefined;
    nom?: string | undefined;
    parDefaut?: boolean;
    hasCustomImage?: boolean;
    canBeCreated?: boolean | undefined;
    pourcentageAide?: number | undefined;
}

export enum ChampDepense {
    None = "none",
    Autre = "autre",
    SalairesArtisteEnregistrement = "salairesArtisteEnregistrement",
    SalairesArtisteRepetition = "salairesArtisteRepetition",
    SalairesArtisteRepresentation = "salairesArtisteRepresentation",
    SalairesArtisteMensualisation = "salairesArtisteMensualisation",
    ChargesSocialesPatronalesArtistes = "chargesSocialesPatronalesArtistes",
    AutresSalairesArtistiquesChargesSocialesPatronalesIncluses = "autresSalairesArtistiquesChargesSocialesPatronalesIncluses",
    SalairesTechniciensChargesSocialesPatronalesIncluses = "salairesTechniciensChargesSocialesPatronalesIncluses",
    SalairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses = "salairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses",
    LocationSalle = "locationSalle",
    Assurances = "assurances",
    Defraiements = "defraiements",
    PublicitePromotion = "publicitePromotion",
    Organisme = "organisme",
    Musiciens = "musiciens",
    Danseurs = "danseurs",
    Choristes = "choristes",
    Chanteurs = "chanteurs",
    Comediens = "comediens",
    ChefsOrchestre = "chefsOrchestre",
    ChargesPatronales = "chargesPatronales",
    CongesSpectales = "congesSpectales",
    Auteurs = "auteurs",
    MetteursEnScene = "metteursEnScene",
    Choregraphes = "choregraphes",
    DecorateursCostumiers = "decorateursCostumiers",
    CommandesMusicales = "commandesMusicales",
    Agessa = "agessa",
    AdministrationCoordination = "administrationCoordination",
    TelephoneFaxEnvois = "telephoneFaxEnvois",
    TechniciensIngenieurs = "techniciensIngenieurs",
    Divers = "divers",
    CommunicationPublicite = "communicationPublicite",
    AttacheDePresse = "attacheDePresse",
    FraisDeFonctionnementLocation = "fraisDeFonctionnementLocation",
    MasseSalarialeArtistiqueEstimeeContratsVente = "masseSalarialeArtistiqueEstimeeContratsVente",
    ContratsVentes = "contratsVentes",
    BilletsAvion = "billetsAvion",
    BilletsTrain = "billetsTrain",
    LocationVoiture = "locationVoiture",
    Hotel = "hotel",
    Restauration = "restauration",
    Carburant = "carburant",
    TransportInstruments = "transportInstruments",
    Hebergement = "hebergement",
    CotisationAFC = "cotisationAFC",
    SalaireArtistes = "salaireArtistes",
    RealisationEtImpressionInvitations = "realisationEtImpressionInvitations",
    EnvoisEtInsertionsPresse = "envoisEtInsertionsPresse",
    Deplacements = "deplacements",
    FraisOrganisation = "fraisOrganisation",
    Sacem = "sacem",
    Arrangeur = "arrangeur",
    LocationStudio = "locationStudio",
    LocationMateriel = "locationMateriel",
    SalairesEnseignantsPermanents = "salairesEnseignantsPermanents",
    ChargesSocialesEnseignantsPermanents = "chargesSocialesEnseignantsPermanents",
    SalairesEnseignantsVacataires = "salairesEnseignantsVacataires",
    ChargesSocialesEnseignantsVacataires = "chargesSocialesEnseignantsVacataires",
    Loyers = "loyers",
    FraisFonctionnement = "fraisFonctionnement",
    Cotisations = "cotisations",
    FraisBancaires = "fraisBancaires",
    TaxesSalaires = "taxesSalaires",
    FormationProfessionnelleContinue = "formationProfessionnelleContinue",
    TaxeApprentissage = "taxeApprentissage",
    DevisRealisation = "devisRealisation",
    DroitsPourUtilisationsSecondaires = "droitsPourUtilisationsSecondaires",
    DroitsSurDocumentsArchives = "droitsSurDocumentsArchives",
    DroitsPhotographiques = "droitsPhotographiques",
    DroitsAuteur = "droitsAuteur",
    BandesEtFournitures = "bandesEtFournitures",
    SalaireVerseSuiteAnnulations = "salaireVerseSuiteAnnulations",
    IndemniteVerseSuiteAnnulations = "indemniteVerseSuiteAnnulations",
    PrestationTechnique = "prestationTechnique",
    Copiste = "copiste",
    SalairesPersonnelsAdministratifs = "salairesPersonnelsAdministratifs",
    ChargesSocialesPersonnelsAdministratifs = "chargesSocialesPersonnelsAdministratifs",
    AutresSalairesChargesSocialesIncluses = "autresSalairesChargesSocialesIncluses",
    SalairesArtisteConcert = "salairesArtisteConcert",
    SalairesArtisteEngagementDirect = "SalairesArtisteEngagementDirect",
    CotisationPatronalesEngagementDirect = "CotisationPatronalesEngagementDirect",
    SalairesArtisteContratVente = "SalairesArtisteContratVente",
    CotisationPatronalesContratVente = "CotisationPatronalesContratVente"
}

export enum ChampFinancement {
    None = "none",
    Autre = "autre",
    VenteTotaleBillets = "venteTotaleBillets",
    VenteTiers = "venteTiers",
    RecettesAnnexes = "recettesAnnexes",
    ContrepartiesEnServicesOuCoProduction = "contrepartiesEnServicesOuCoProduction",
    ApportsPersonnelsGarantis = "apportsPersonnelsGarantis",
    FondsEuropeens = "fondsEuropeens",
    MinistereDeLaCulture = "ministereDeLaCulture",
    Drac = "drac",
    ConseilRegional = "conseilRegional",
    ConseilGeneral = "conseilGeneral",
    CommunauteDeCommunes = "communauteDeCommunes",
    Municipalite = "municipalite",
    Cnm = "cnm",
    SacemOuAssociationBeaumarchais = "sacemOuAssociationBeaumarchais",
    Sacd = "sacd",
    ScpPouSPPF = "scpPouSPPF",
    Adami = "adami",
    MontantDemandeSPEDIDAM = "montantDemandeSPEDIDAM",
    VenteSpectacles = "venteSpectacles",
    VenteBilletsEscompte = "venteBilletsEscompte",
    ContrePartiesEnServices = "contrePartiesEnServices",
    CoProduction = "coProduction",
    Divers = "divers",
    Sacem = "sacem",
    Fcm = "fcm",
    FinancementParticipatifOuCampagneCrowdfunding = "financementParticipatifOuCampagneCrowdfunding",
    FondSoutienProfessionnalisationAFC = "fondSoutienProfessionnalisationAFC",
    AutresPartenaires = "autresPartenaires",
    Vente = "vente",
    ConseilDepartemental = "conseilDepartemental",
    Cnc = "cnc",
    Cours = "cours",
    Adhesions = "adhesions",
    AfdasCifCnfpt = "afdasCifCnfpt",
    AutresRecettesExploitation = "autresRecettesExploitation",
    Ville = "ville",
    ApportFondsPropres = "apportFondsPropres",
    ApportProducteur = "apportProducteur",
    ApportCoProducteur = "apportCoProducteur",
    ApportEditeurDeMusique = "apportEditeurDeMusique",
    IndemnisationChomageSalaireArtiste = "indemnisationChomageSalaireArtiste",
    IndemnisationChomageAutreSalaire = "indemnisationChomageAutreSalaire",
}

export interface ChangeEmailDto {
    newEmail?: string | undefined;
    token?: string | undefined;
}

export interface ChangePasswordDto {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export interface ChangePasswordWithResetTokenDto {
    userName?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface ChiffresClesDto {
    id?: string;
    anneeScolaireDebut?: Date;
    anneeScolaireFin?: Date;
    nombreEnseignantCDI?: number;
    nombreEnseignantCDD?: number;
    nombreEnseignantCDII?: number;
    nombreMusicienIntermittent?: number;
    nombreEmployeAdministratif?: number;
    nombreEmployeAdministratifETP?: number;
    nombreTotalEnseignant?: number;
    nombreTotalEnseignantETP?: number;
    nombreEtudiantCyclePro?: number;
    nombreEtudiantAFDAS?: number;
    nombreEtudiantCNFPT?: number;
    nombreEtudiantCIF?: number;
    nombreEtudiantFormationContinue?: number;
    nombreEtudiantFormationInitiale?: number;
    nombreEleveAmateur?: number;
    readonly nombreEtudiantCycleProfessionnelCurrentYear?: number;
    readonly nombreEtudiantCycleLoisirCurrentYear?: number;
    nombreEtudiantCycleProfessionnelN1?: number;
    nombreEtudiantCycleLoisirN1?: number;
    nombreEtudiantCycleProfessionnelN2?: number;
    nombreEtudiantCycleLoisirN2?: number;
    nombreEtudiantCycleProfessionnelN3?: number;
    nombreEtudiantCycleLoisirN3?: number;
    nombreEtudiantCycleProfessionnelN4?: number | undefined;
    nombreEtudiantCycleLoisirN4?: number | undefined;
    chiffreAffaire?: number;
    salaires?: number;
    chiffreAffaireN1?: number;
    salairesN1?: number;
    chiffreAffaireN2?: number;
    salairesN2?: number;
    chiffreAffaireN3?: number;
    salairesN3?: number;
    chiffreAffaireN4?: number | undefined;
    salairesN4?: number | undefined;
}

export interface ChiffresClesViewModelDto {
    dateDebut?: Date;
    dateFin?: Date;
    chiffresCles?: ChiffresClesDto;
    previousChiffresCles?: ChiffresClesDto;
    aidesByYear?: AidesFonctionnementByYearModel[] | undefined;
}

export enum Civilite {
    None = "none",
    Monsieur = "monsieur",
    Madame = "madame",
}

export interface CommissionDto {
    id?: string;
    bordereauId?: string | undefined;
    nom?: string | undefined;
    statut?: StatutCommission;
    dateOuverture?: Date | undefined;
    dateDebut?: Date;
    dateFin?: Date;
    dateCloture?: Date | undefined;
    dateClotureCA?: Date | undefined;
    dateFinSoumission?: Date;
    dateCA?: Date | undefined;
    groupe?: GroupeCommission;
    commissionSpecifique?: boolean;
    commissionSpecifiqueCommentaire?: string | undefined;
    decalageGroupes?: boolean;
    visibleCalendrier?: boolean;
    pointsDivers?: string | undefined;
    contenuPV?: string | undefined;
    pointsDiversCA?: string | undefined;
    montantMax?: number | undefined;
    canEdit?: boolean;
    dateDebutSoumission?: Date;
    categoriesDossier?: CategorieDossierDto[] | undefined;
    pv?: string | undefined;
    pvca?: string | undefined;
    convocation?: string | undefined;
    dossier?: number;
    montantDemande?: number;
    montantAttribue?: number;
    reaffectation?: number;
}

export interface ConditionDto {
    questionId?: string | undefined;
    operator?: ConditionOperator;
    invert?: boolean;
    operand?: any | undefined;
    operands?: any[] | undefined;
    operandQuestionId?: string | undefined;
}

export enum ConditionOperator {
    Empty = "empty",
    Equal = "equal",
    AnyOf = "anyOf",
    LesserThan = "lesserThan",
}

export interface ContactDto {
    id?: string;
    poste?: TypePoste;
    civilite?: Civilite;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
}

export interface CreateArtisteDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    siteInternet?: string | undefined;
    emploi?: Emploi;
    styleMusicalId?: string | undefined;
    instrumentId?: string | undefined;
    artistePrincipal?: boolean;
    formation?: string | undefined;
    isGenerationSpedidam?: boolean;
    isAssociated?: boolean;
    isTitulaire?: boolean;
    isEngagementDirect?: boolean;
    cachets?: CreateCachetDto[] | undefined;
    salaires?: CreateSalaireDto[] | undefined;
}

export interface CreateCachetDto {
    lieuDateIds?: string[] | undefined;
    montantBrut?: number;
    tauxChargesPatronales?: number;
    count?: number;
}

export interface CreateChiffresClesDto {
    nombreEnseignantCDI?: number;
    nombreEnseignantCDD?: number;
    nombreEnseignantCDII?: number;
    nombreMusicienIntermittent?: number;
    nombreEmployeAdministratif?: number;
    nombreEmployeAdministratifETP?: number;
    nombreTotalEnseignant?: number;
    nombreTotalEnseignantETP?: number;
    nombreEtudiantCyclePro?: number;
    nombreEtudiantAFDAS?: number;
    nombreEtudiantCNFPT?: number;
    nombreEtudiantCIF?: number;
    nombreEtudiantFormationContinue?: number;
    nombreEtudiantFormationInitiale?: number;
    nombreEleveAmateur?: number;
    readonly nombreEtudiantCycleProfessionnelCurrentYear?: number;
    readonly nombreEtudiantCycleLoisirCurrentYear?: number;
    nombreEtudiantCycleProfessionnelN1?: number;
    nombreEtudiantCycleLoisirN1?: number;
    nombreEtudiantCycleProfessionnelN2?: number;
    nombreEtudiantCycleLoisirN2?: number;
    nombreEtudiantCycleProfessionnelN3?: number;
    nombreEtudiantCycleLoisirN3?: number;
    nombreEtudiantCycleProfessionnelN4?: number | undefined;
    nombreEtudiantCycleLoisirN4?: number | undefined;
    chiffreAffaire?: number;
    salaires?: number;
    chiffreAffaireN1?: number;
    salairesN1?: number;
    chiffreAffaireN2?: number;
    salairesN2?: number;
    chiffreAffaireN3?: number;
    salairesN3?: number;
    chiffreAffaireN4?: number | undefined;
    salairesN4?: number | undefined;
}

export interface CreateContactDto {
    poste?: TypePoste;
    civilite?: Civilite;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
}

export interface CreateDepenseDto {
    intitule?: string | undefined;
    commentaire?: string | undefined;
    type?: TypeDepense;
    champ?: ChampDepense;
    montant?: number;
    confirmationMontant?: boolean | undefined;
    document?: DocumentUploadInfoDto;
}

export interface CreateDossierDto {
    categorieId?: string;
}

export interface CreateFinancementDto {
    intitule?: string | undefined;
    commentaire?: string | undefined;
    type?: TypeFinancement;
    champ?: ChampFinancement;
    montant?: number;
    confirmationMontant?: boolean | undefined;
    document?: DocumentUploadInfoDto;
}

export interface CreateLieuDto {
    adresseId?: string | undefined;
    adresseLabel?: string | undefined;
    departement?: string | undefined;
    ville?: string | undefined;
    paysId?: string;
    adresse?: string | undefined;
    nomLieu?: string | undefined;
    jauge?: number | undefined;
    dates?: Date[] | undefined;
    typePrestation?: TypePrestation;
    description?: string;
}

export interface CreateMessageDto {
    contenu?: string | undefined;
}

export interface CreateOrUpdateAdresseDto {
    line1?: string | undefined;
    line2?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
}

export interface CreateOrUpdateAidesFonctionnementDto {
    aidesByYear?: AidesFonctionnementByYearModel[] | undefined;
}

export interface CreateOrUpdateEtapeDto {
    id?: string | undefined;
    order?: number;
    paysId?: string;
    escaleAllerPaysId?: string | undefined;
    escaleRetourPaysId?: string | undefined;
    typeTransport?: TypeTransport;
}

export interface CreateOrUpdateResponsableDossierDto {
    civilite?: Civilite;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
}

export interface CreateOrUpdateTrajetDto {
    versementId?: string | undefined;
    etapes?: CreateOrUpdateEtapeDto[] | undefined;
    artisteIds?: string[] | undefined;
    versementArtisteIds?: string[] | undefined;
}

export interface CreateOrUpdateVersementArtisteDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    emploi?: Emploi;
    styleMusicalId?: string | undefined;
    instrumentId?: string | undefined;
    isTitulaire?: boolean;
    totalSalairesBruts?: number;
    totalCharges?: number;
    datesTravailles?: Date[] | undefined;
}

export interface CreateSalaireDto {
    lieuDateIds?: string[] | undefined;
    montantBrut?: number;
    tauxChargesPatronales?: number;
}

export interface CreateStructureDto {
    siret?: string | undefined;
    raisonSociale?: string | undefined;
    codeAPE?: string | undefined;
    nomenclatureAPE?: string | undefined;
    adresse?: CreateOrUpdateAdresseDto;
    adresseCorrespondance?: CreateOrUpdateAdresseDto;
    formeJuridiqueId?: string;
    correspondant?: CreateContactDto;
    president?: CreateContactDto;
    informations?: string | undefined;
    codeLangue?: string | undefined;
    documents?: DocumentUploadInfoDto[] | undefined;
}

export interface CreateVersementDto {
    type?: TypeVersement;
    mode?: ModeVersement;
}

export interface CritereDossierLightDto {
    id?: string;
    uris?: { [key: string]: string; } | undefined;
    dateDebut?: Date;
    statutGenerationPdf?: StatutGenerationPdf;
    categorieId?: string;
    categorie?: CategorieDossierDto;
    commissionId?: string | undefined;
}

export interface CurrentCritereDossierDto {
    id?: string;
    contenu?: { [key: string]: string; } | undefined;
    categorie?: CategorieDossierDto;
}

export interface CurrentDossierInfoDto {
    dossierNom?: string | undefined;
    dossierStatut?: string | undefined;
    categorieNom?: string | undefined;
    structureNom?: string | undefined;
    commissionNom?: string | undefined;
}

export interface DemandeVersementContratCachetDto {
    totalRemunerationBrut?: number;
    totalChargePatronales?: number;
    categoryDossierId?: number;
    totalMontantPrevisionnel?: number;
    artistes?: VersementArtisteDto[] | undefined;
    enseignants?: EnseignantRemunerationDto[] | undefined;
    depenses?: DepenseDto[] | undefined;
    commentaire?: string | undefined;
}

export interface DemandeVersementDetailDto {
    nomDossier?: string | undefined;
    statutVersement?: StatutVersement;
    dateDebutProjet?: Date | undefined;
    dateFinProjet?: Date | undefined;
    baseCalculSpedidam?: number;
    montantAttribue?: number;
    categorieNom?: string | undefined;
    dateSoumission?: Date | undefined;
    montantDemande?: number;
    montantVerse?: number | undefined;
    valideParDSV?: boolean;
    donneeBancaire?: DonneesBancairesDto;
}

export interface DemandeVersementInfosDto {
    nom?: string | undefined;
    responsableFullName?: string | undefined;
    mailResponsable?: string | undefined;
    telResponsable?: string | undefined;
    categorieDossier?: string | undefined;
    isApi?: boolean;
    baseCalcul?: number;
    montantDemande?: number;
    montantAttribue?: number;
    montantPercu?: number;
    hasSendDocPromoImage?: boolean | undefined;
    commissionsDebut?: Date;
    commissionFin?: Date;
    dateProjetDebut?: Date | undefined;
    dateProjetFin?: Date | undefined;
    dateSoumission?: Date | undefined;
    documentAPI?: DocumentDto | undefined; //DocumentUploadInfoDto | undefined;
}

export interface DemandeVersementLieuDateDto {
    prestations?: LieuxDto[] | undefined;
}

export interface DemandeVersementPieceJointeViewModelDto {
    typeDeDocuments?: TypeDeDocumentDto[] | undefined;
    documents?: DocumentDto[] | undefined;
}

export interface DepenseBlockViewModelDto {
    type?: TypeDepense;
    montantMin?: number | undefined;
    montantMax?: number | undefined;
    depenses?: DepenseViewModelDto[] | undefined;
}

export interface DepenseDto {
    id?: string;
    type?: TypeDepense;
    champ?: ChampDepense;
    montant?: number;
    montantRealise?: number | undefined;
    confirmationMontant?: boolean | undefined;
    intitule?: string | undefined;
    commentaire?: string | undefined;
    document?: DocumentWithValidationDto;
}

export interface DepenseViewModelDto {
    montant?: number | undefined;
    montantMax?: number | undefined;
    montantMin?: number | undefined;
    isEditable?: boolean;
    champ?: ChampDepense;
    hasAttachment?: boolean;
    needConfirmation?: boolean;
}

export interface DescriptionProjetViewModelDto {
    donneesBancaires?: DonneesBancairesDto;
    questionsBlocks?: QuestionBlockDto[] | undefined;
    answers?: { [key: string]: any; } | string | undefined;
}

export interface DisciplineDto {
    id?: string | undefined;
    text?: { [key: string]: string; } | undefined;
}

export interface DiscussionDossierDto {
    id?: string;
    nom?: string | undefined;
    description?: string | undefined;
    aMessageNonLu?: boolean;
    dateDernierMessage?: Date | undefined;
    statut?: StatutDiscussion;
    objet?: ObjetDiscussion;
    interlocuteur?: string | undefined;
    messages?: DiscussionMessageDto[] | undefined;
    dossierId?: string;
    categorieCode?: string | undefined;
    dossierNumero?: string
}

export interface DiscussionMessageDto {
    discussionId?: string;
    messageId?: string;
    estLu?: boolean;
    message?: MessageDto;
}

export interface DiscussionStructureDto {
    id?: string;
    nom?: string | undefined;
    description?: string | undefined;
    aMessageNonLu?: boolean;
    dateDernierMessage?: Date | undefined;
    statut?: StatutDiscussion;
    objet?: ObjetDiscussion;
    interlocuteur?: string | undefined;
    messages?: DiscussionMessageDto[] | undefined;
    structureId?: string;
}

export interface DocumentDto {
    id?: string;
    fileName?: string | undefined;
    name?: string | undefined;
    contentType?: string | undefined;
    uri?: string | undefined;
    type?: TypeDeDocumentDto;
    extraInfo?: DocumentExtraInfoDto[] | undefined;
    expirationDate?: Date | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
}

export interface DocumentExtraInfoDto {
    documentId?: string;
    code?: string | undefined;
    valueType?: TypeDeDocumentExtraInfoValueType;
    jsonValue?: string | undefined;
    readonly value?: any | undefined;
}

export interface DocumentLightDto {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    uri?: string | undefined;
}

export enum DocumentScope {
    None = "none",
    Structure = "structure",
    Dossier = "dossier",
    Commission = "commission",
}

export interface DocumentUploadInfoDto {
    id?: string | undefined;
    typeId?: string;
    partName?: string | undefined;
    extraInfos?: { [key: string]: any; } | undefined;
}

export interface DocumentWithValidationDto {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    uri?: string | undefined;
    type?: TypeDeDocumentDto;
    extraInfo?: DocumentExtraInfoDto[] | undefined;
    expirationDate?: Date | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    validee?: boolean | undefined;
    commentaires?: string | undefined;
    actionType?: string | undefined;
}

export interface DonneesBancairesDto {
    id?: string;
    iban?: string | undefined;
    bic?: string | undefined;
    banque?: string | undefined;
    adresse?: AdresseDto;
    rib?: DocumentWithValidationDto;
    createdAt?: Date;
    lastModifiedAt?: Date;
    canEditRib?: boolean;
}

export interface DossierArtistesViewModelDto {
    typeCachetRequired?: TypePrestation[] | undefined;
    formationRequired?: boolean;
    stylesMusicauxMultiChoix?: boolean;
    artistePrincipalInfoRequired?: boolean;
    generationSpedidamInfoRequired?: boolean;
    artisteTitulaireInfoRequired?: boolean;
    artisteAdditionnelInfoRequired?: boolean;
    mensualisation?: boolean;
    nombreCachetMinimum?: number;
    emplois?: Emploi[] | undefined;
    stylesMusicaux?: StyleMusicalDto[] | undefined;
    instruments?: InstrumentDto[] | undefined;
    lieuDatesByType?: { [key: string]: LieuDateDto[]; } | undefined;
    remunerations?: RemunerationDto[] | undefined;
    groupesEmploi?: any[] | undefined;
}

export interface DossierDetailsDto {
    id?: string;
    isEditable?: boolean;
    dsv?: boolean;
    hasVersement?: boolean;
    nom?: string | undefined;
    numero?: string | undefined;
    description?: string | undefined;
    commentaires?: string | undefined;
    commentairesInstruction?: string | undefined;
    structure?: StructureLightDto;
    documents?: DocumentWithValidationDto[] | undefined;
    descriptionPiecesJointes?: DocumentLightDto[] | undefined;
    statut?: StatutDossier | any;
    categorie?: CategorieDossierDto;
    responsable?: ResponsableDossierDto;
    trajets?: TrajetDto[] | undefined;
    hasRepetition?: boolean;
    hasRepresentation?: boolean;
    hasEnregistrement?: boolean;
    hasConcert?: boolean;
    hasMensualisation?: boolean;
    artistes?: ArtisteDetailsDto[] | undefined;
    enseignants?: EnseignantDto[] | undefined;
    salaries?: SalarieDto[] | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    dateProlongation?: Date | undefined;
    dates?: LieuDateDetailsDto[] | undefined;
    budget?: BudgetDto;
    budgetViewModel?: BudgetViewModelDto;
    chiffresCles?: ChiffresClesDto;
    chargeInstructionId?: number | undefined;
}

export interface DossierDto {
    id?: string;
    numero?: string | undefined;
    canVersement?: boolean;
    statut?: StatutDossier;
    structureId?: string;
    categorieId?: string;
    categorieNom?: string | undefined;
    categorieCode?: string | undefined;
    nom?: string | undefined;
    description?: string | undefined;
    blocageAvis?: boolean;
    aMessageNonLu?: boolean;
    convention?: string | undefined;
    courrierAgreement?: string | undefined;
    lettreRefus?: string | undefined;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
}

export interface DossierDtoSortedFilteredPage {
    readonly actualCount?: number;
    readonly items?: DossierDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
    readonly sortTerms?: SortTerm[] | undefined;
    readonly filterTerms?: FilterTerm[] | undefined;
}

export interface DossierEnseignantsViewModelDto {
    disciplines?: DisciplineDto[] | undefined;
    stylesMusicaux?: StyleMusicalDto[] | undefined;
    instruments?: InstrumentDto[] | undefined;
}

export interface DossierInfosProjetViewModelDto {
    responsableDossier?: ResponsableDossierDto;
    questionBlocks?: QuestionBlockDto[] | undefined;
    answers?: { [key: string]: any; } | undefined;
}

export interface DossierVersementsViewModelDto {
    typesVersements?: TypeVersement[] | undefined;
    modesVersements?: ModeVersement[] | undefined;
    versements?: VersementDtoSortedFilteredPage;
    numeroDossierToDo?: string | undefined;
}

export enum Emploi {
    None = "none",
    Musicien = "musicien",
    Chanteur = "chanteur",
    ChefOrchestre = "chefOrchestre",
    Choriste = "choriste",
    Comedien = "comedien",
    Circassien = "circassien",
    Danseur = "danseur",
    Marionnettiste = "marionnettiste",
}
export enum Groupe {
    None = "none",
    Musiciens = "musiciens",
    Autre = "autre",   
}

export enum GroupeCodeValues {
    Musiciens = "MS",
    Autre = "OTH",   
}

export interface EmploiComparisonConstraintDto {
    more?: Emploi[] | undefined;
    less?: Emploi[] | undefined;
}

export interface EnseignantDto {
    disciplinesIds?: string[] | undefined;
    otherDiscipline?: string | undefined;
    readonly disciplines?: DisciplineDto[] | undefined;
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    ville?: string | undefined;
    instrument?: InstrumentDto;
    qualification?: QualificationEnseignant;
    typeContrat?: TypeContrat;
    statut?: StatutEnseignant;
    remunerationBruteAnnuelle?: number;
    montantChargesPatronales?: number;
    tarifHoraireBrut?: number;
    remunerationPremierTrimestre?: number;
    contratEngagement?: DocumentDto;
    justificatifRemuneration?: DocumentDto;
}

export interface EnseignantDtoPage {
    readonly actualCount?: number;
    readonly items?: EnseignantDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
}

export interface EnseignantRemunerationDto {
    disciplinesIds?: string[] | undefined;
    otherDiscipline?: string | undefined;
    readonly disciplines?: DisciplineDto[] | undefined;
    id?: string;
    remunerationBruteAnnuelle?: number;
    montantChargesPatronales?: number;
    remunerationPremierTrimestre?: number | undefined;
    justificatifRemuneration?: DocumentLightDto;
}

export interface EnseignantValidationDto {
    errors?: EnseignantValidationErrorDto[] | undefined;
}

export interface EnseignantValidationErrorDto {
    contrat?: TypeContrat;
    numberEnseignantRequired?: number | undefined;
}

export enum Equipements {
    None = "none",
    PcBureau = "pcBureau",
    PcPortable = "pcPortable",
    Tablette = "tablette",
    Imprimante = "imprimante",
    TelephonePortable = "telephonePortable",
    Autre = "autre",
}

export enum EtapeCreationDossier {
    None = "none",
    ValidationStructure = "validationStructure",
    Type = "type",
    Criteres = "criteres",
    InformationsProjet = "informationsProjet",
    ChiffresCles = "chiffresCles",
    SalarieArtistes = "salarieArtistes",
    LieuxDates = "lieuxDates",
    ContratsCachets = "contratsCachets",
    Trajets = "trajets",
    Enseignants = "enseignants",
    Budget = "budget",
    DescriptionProjet = "descriptionProjet",
    Validation = "validation",
}

export enum EtapeDemandeVersement {
    None = "none",
    ValidationStructure = "validationStructure",
    ValidationDocumentStructure = "validationDocumentStructure",
    InformationsProjet = "informationsProjet",
    ValidationArtiste = "validationArtiste",
    ValidationEnseignant = "validationEnseignant",
    ValidationDeplacement = "validationDeplacement",
    PieceJointe = "pieceJointe",
    ConfirmationRIB = "confirmationRIB",
    Recapitulatif = "recapitulatif",
}

export interface EtapeDto {
    id?: string;
    order?: number;
    pays?: PaysDto;
    escaleAllerPays?: PaysDto;
    escaleRetourPays?: PaysDto;
    typeTransport?: TypeTransport;
}

export interface ExceptionModel {
    type?: string | undefined;
    readonly message?: string | undefined;
    readonly stackTrace?: string[] | undefined;
    innerException?: ExceptionModel;
}

export enum FilterOperator {
    Equals = "equals",
    NotEquals = "notEquals",
    GreaterThan = "greaterThan",
    LessThan = "lessThan",
    GreaterThanOrEqualTo = "greaterThanOrEqualTo",
    LessThanOrEqualTo = "lessThanOrEqualTo",
    Contains = "contains",
    StartsWith = "startsWith",
}

export interface FilterTerm {
    filter?: string | undefined;
    readonly names?: string[] | undefined;
    operatorParsed?: FilterOperator;
    readonly values?: string[] | undefined;
    readonly operator?: string | undefined;
    readonly operatorIsCaseInsensitive?: boolean;
    readonly operatorIsNegated?: boolean;
}

export interface FinancementBlockViewModelDto {
    type?: TypeFinancement;
    montantMin?: number | undefined;
    montantMax?: number | undefined;
    financements?: FinancementViewModelDto[] | undefined;
}

export interface FinancementDto {
    id?: string;
    type?: TypeFinancement;
    champ?: ChampFinancement;
    montant?: number;
    confirmationMontant?: boolean | undefined;
    intitule?: string | undefined;
    commentaire?: string | undefined;
    document?: DocumentLightDto;
}

export interface FinancementLightDto {
    id?: string | undefined;
    champ?: ChampFinancement;
    montant?: number;
}

export interface FinancementViewModelDto {
    montantMax?: number | undefined;
    isEditable?: boolean;
    champ?: ChampFinancement;
    hasAttachment?: boolean;
    needConfirmation?: boolean;
}

export interface FOCurrentUserDto {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    statutStructure?: StatutStructure;
}

export interface FormeJuridiqueDto {
    id?: string;
    code?: string | undefined;
    nom?: string | undefined;
    categorieId?: string;
}

export interface GeoAdresseDto {
    id?: string | undefined;
    label?: string | undefined;
    numero?: string | undefined;
    rue?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export enum GroupeCommission {
    None = "none",
    A = "a",
    B = "b",
    C = "c",
    Suppleant = "suppleant",
}

export interface InstrumentDto {
    id?: string;
    code?: string | undefined;
    intitule?: { [key: string]: string; } | undefined;
}

export interface LieuDateDetailsDto {
    id?: string;
    typePrestation?: TypePrestation;
    departement?: string | undefined;
    ville?: string | undefined;
    lieu?: string | undefined;
    pays?: PaysDto;
    date?: Date;
    artistes?: ArtisteLightDto[] | undefined;
}

export interface LieuDateDto {
    id?: string;
    date?: Date;
    typePrestation?: TypePrestation;
    description?: string;
}

export interface LieuDto {
    id?: string;
    departement?: string | undefined;
    ville?: string | undefined;
    pays?: PaysDto;
    adresseId?: string | undefined;
    adresseLabel?: string | undefined;
    adresse?: string | undefined;
    nomLieu?: string | undefined;
    jauge?: number | undefined;
    longitude?: number;
    latitude?: number;
    dates?: LieuDateDto[] | undefined;
    typePrestation?: TypePrestation;
    description?: string;
}

export interface LieuValidationDto {
    errors?: LieuValidationError[] | undefined;
}

export interface LieuValidationError {
    types?: TypePrestation[] | undefined;
    max?: number | undefined;
    min?: number | undefined;
    maxDuration?: number | undefined;
    maxMonthDuration?: number | undefined;
    minPrestation?: number | undefined;
    withDifferentPlace?: boolean | undefined;
    allRepresentationsMustBeDuringEvenement?: boolean;
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
}

export interface LieuxDto {
    type?: TypePrestation;
    lieux?: LieuDto[] | undefined;
}

export interface LoginDto {
    userName?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
}

export interface MasseSalarialeDto {
    montantCachets?: { [key: string]: number; } | undefined;
    montantSalaires?: number;
    chargesPatronales?: number;
}

export interface MessageAlerteDto {
    id?: string;
    nom?: string | undefined;
    message?: string | undefined;
    afficher?: boolean;
}

export interface MessageDto {
    contenu?: string | undefined;
    auteur?: AdelUserDto;
    createdAt?: Date;
    piecesJointes?: PieceJointeDto[] | undefined;
}

export interface MessagerieDto {
    discussionsStructure?: DiscussionStructureDto[] | undefined;
    discussionsDossiers?: DiscussionDossierDto[] | undefined;
    discussionsStructureCount?: number | undefined;
    discussionsDossierseCount?: number | undefined;
}

export interface MinimumEmploiCountConstraintDto {
    minimum?: number;
    emplois?: Emploi[] | undefined;
}

export enum ModeVersement {
    None = "none",
    Automatique = "automatique",
    Manuel = "manuel",
    Programme = "programme",
}

export interface NotificationsDto {
    aMessageNonLu?: boolean;
    notificationsCount?: number;
}

export enum ObjetDiscussion {
    None = "none",
    InformationGeneral = "informationGeneral",
    MiseAJourCompte = "miseAJourCompte",
    AbsenceLogo = "absenceLogo",
    ConventionNonConforme = "conventionNonConforme",
    ConventionRecueHorodate = "conventionRecueHorodate",
    ContratNonConforme = "contratNonConforme",
    DecisionDefavorable = "decisionDefavorable",
    DecisionFavorable = "decisionFavorable",
    DemandeVersementNonConforme = "demandeVersementNonConforme",
    DemandeVersementAcompteNonConforme = "demandeVersementAcompteNonConforme",
    DemandeVersementSoldeNonConforme = "demandeVersementSoldeNonConforme",
    DemandeVersementAFaire = "demandeVersementAFaire",
    DossierHorsCritères = "dossierHorsCritères",
    DossierIncomplet = "dossierIncomplet",
    EnAttenteConventionSigne = "enAttenteConventionSigne",
    EnAttenteDelegationSignature = "enAttenteDelegationSignature",
    EnAttenteDemandeDerogation = "enAttenteDemandeDerogation",
    EnAttenteSupportPhysique = "enAttenteSupportPhysique",
    EnAttenteValidationServiceJuridique = "enAttenteValidationServiceJuridique",
    EnAttenteValidationServiceSpectacleVivant = "enAttenteValidationServiceSpectacleVivant",
    ExamenDossierReporte = "examenDossierReporte",
    FeuillePresenceNonConforme = "feuillePresenceNonConforme",
    ImpossibleOuvrirPieceJointe = "impossibleOuvrirPieceJointe",
    LienIndiqueNonValide = "lienIndiqueNonValide",
    RemunerationArtisteNonConforme = "remunerationArtisteNonConforme",
    MiseAJourPiecesJointesMonCompte = "miseAJourPiecesJointesMonCompte",
    NonRespectCriteres = "nonRespectCriteres",
    ReaffectationAide = "reaffectationAide",
    UrgentRappelAvantReaffectationAide = "urgentRappelAvantReaffectationAide",
    VersementProrata = "versementProrata",
    VersementAide = "versementAide",
    DemandeRemboursement = "demandeRemboursement",
    DemandeDeComplementInformation = "demandeDeComplementInformation"
}

export interface PageVitrineDto {
    id?: string;
    nom?: { [key: string]: string; } | undefined;
    ordre?: number;
    contenu?: { [key: string]: string; } | undefined;
    urlSlug?: { [key: string]: string; } | undefined;
}

export interface PasswordResetRequestDto {
    userName?: string | undefined;
}

export interface PaysDto {
    id?: string;
    nom?: string | undefined;
    estEurope?: boolean;
    estAimable?: boolean;
}

export interface PieceJointeDto {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    uri?: string | undefined;
}

export interface PresetAnswerDto {
    value?: any | undefined;
    isModifiable?: boolean;
}

export interface PrestationsViewModelDto {
    typesPrestation?: TypePrestation[] | undefined;
    dateRange?: boolean;
    franceByDefault?: boolean;
    dateMinimum?: Date | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    code?: ProblemDetailsCode;
    exception?: ExceptionModel;
    additionalDetails?: AdditionalDetails;
}

export interface PropertyValidatorInfo {
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
    name?: string | undefined;
}

export enum QualificationEnseignant {
    None = "none",
    Autodidacte = "autodidacte",
    CertificatAptitude = "certificatAptitude",
    DiplomeEtat = "diplomeEtat",
    Autre = "autre",
}

export interface QuestionBlockDto {
    id?: string | undefined;
    title?: { [key: string]: string; } | undefined;
    questions?: QuestionDto[] | undefined;
}

export interface QuestionDto {
    id?: string | undefined;
    text?: { [key: string]: string; } | undefined;
    answerType?: AnswerType;
    answerMinLength?: number | undefined;
    answerMaxLength?: number | undefined;
    answerMinValue?: any | undefined;
    answerMaxValue?: any | undefined;
    isRequired?: boolean;
    choices?: AnswerChoiceDto[] | undefined;
    conditions?: ConditionDto[] | undefined;
    presetAnswer?: PresetAnswerDto;
    fileExtensions?: string[] | undefined;
    informationLink?: string | undefined;
    arrayItemsQuestions?: QuestionDto[] | undefined;
    cssClass?: string | undefined;
    isShown?: boolean;
    model?: any
}

export interface RecapitulatifVersementDto {
    totalMontantPrevisionnel?: number;
    totalMontantRealise?: number;
    pourcentageRealise?: number;
    montantAccorde?: number;
    montantDejaVerse?: number | undefined;
    categorie?: string | undefined;
    aideEstimee?: number | undefined;
}

export interface RemunerationDto {
    id?: string;
    categorieDossier?: CategorieDossierDto;
    critereDossier?: CritereDossierLightDto;
    emploi?: Groupe;
    typePrestation?: TypePrestation;
    styleMusical?: StyleMusicalDto;
    montantMinimum?: number;
    estSalaire?: boolean;
}

export interface ResponsableDossierDto {
    civilite?: Civilite;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
}

export interface SalaireDto {
    id?: string;
    montantBrut?: number;
    tauxChargesPatronales?: number;
    dates?: LieuDateDto[] | undefined;
}

export interface SalarieDto {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    adresse?: AdresseDto;
    dateNaissance?: Date;
    dateEmbauchePrevue?: Date;
    salaireBrut?: number;
    cv?: DocumentDto;
    diplome?: DocumentDto;
    conventionCollective?: string | undefined;
    equipements?: Equipements;
    autresEquipements?: string | undefined;
    typesAdresses?: TypesAdresses;
    autreAdresse?: AdresseDto;
}

export interface SortTerm {
    sort?: string | undefined;
    readonly name?: string | undefined;
    readonly descending?: boolean;
}

export enum StatutCommission {
    None = "none",
    Planifiee = "planifiee",
    Figee = "figee",
    EnCours = "enCours",
    EnAttenteCA = "enAttenteCA",
    CaEnCours = "caEnCours",
    Terminee = "terminee",
}

export enum StatutDiscussion {
    None = "none",
    EnCours = "enCours",
    Termine = "termine",
}

export enum StatutDossier {
    None = "none",
    Brouillon = "brouillon",
    SansSuite = "sansSuite",
    Soumis = "soumis",
    PrisEnCharge = "prisEnCharge",
    HorsCriteres = "horsCriteres",
    Renonciation = "renonciation",
    ProgrammeEnCommission = "programmeEnCommission",
    Refuse = "refuse",
    Accepte = "accepte",
    Solde = "solde",
    Reaffecte = "reaffecte",
}

export enum StatutEnseignant {
    None = "none",
    Permanent = "permanent",
    Vacataire = "vacataire",
}

export enum StatutGenerationPdf {
    None = "none",
    Pending = "pending",
    Done = "done",
    Failed = "failed",
}

export enum StatutStructure {
    None = "none",
    Pending = "pending",
    Enabled = "enabled",
    Disabled = "disabled",
    Partial = "partial",
}

export enum StatutVersement {
    None = "none",
    Brouillon = "brouillon",
    Soumis = "soumis",
    Modification = "modification",
    Valide = "valide",
    Verse = "verse",
    PriseEnCharge = "priseEnCharge",
    EnAttente = "enAttente",
    Reaffectation = "reaffectation"
}

export interface StructureDetailsDto {
    id?: string;
    statut?: StatutStructure;
    siret?: string | undefined;
    raisonSociale?: string | undefined;
    codeAPE?: string | undefined;
    nomenclatureAPE?: string | undefined;
    formeJuridique?: FormeJuridiqueDto;
    informations?: string | undefined;
    codeLangue?: string | undefined;
    note?: number | undefined;
    notePro?: number | undefined;
    representantLegal?: ContactDto;
    adresse?: AdresseDto;
    correspondant?: ContactDto;
    adresseCorrespondance?: AdresseDto;
    donneesBancaires?: DonneesBancairesDto;
    documents?: DocumentWithValidationDto[] | undefined;
    requiredDocuments?: TypeDeDocumentDto[] | undefined;
}

export interface StructureDto {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    nom?: string | undefined;
    statut?: StatutStructure;
    codePostal?: string | undefined;
    date?: Date;
    dossiersCount?: number;
}

export interface StructureLightDto {
    id?: string;
    statut?: StatutStructure;
    siret?: string | undefined;
    raisonSociale?: string | undefined;
    codeAPE?: string | undefined;
    codeSpectacleVivant?: string | undefined;
    nomenclatureAPE?: string | undefined;
    formeJuridique?: FormeJuridiqueDto;
    informations?: string | undefined;
    note?: number | undefined;
    notePro?: number | undefined;
    representantLegal?: ContactDto;
    adresse?: AdresseDto;
    correspondant?: ContactDto;
    adresseCorrespondance?: AdresseDto;
    donneesBancaires?: DonneesBancairesDto;
}

export interface StructureSireneInfoDto {
    siret?: string | undefined;
    siren?: string | undefined;
    codeAPE?: string | undefined;
    nomenclatureAPE?: string | undefined;
    raisonSociale?: string | undefined;
    adresse?: AdresseDto;
    formeJuridique?: FormeJuridiqueDto;
    nomPresident?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
    isRegisteredWithAdel?: boolean;
}

export interface StructureValidationContactsDto {
    president?: ContactDto;
    adresse?: AdresseDto;
    correspondant?: ContactDto;
    adresseCorrespondance?: AdresseDto;
}

export interface StyleMusicalDto {
    id?: string;
    code?: string | undefined;
    intitule?: { [key: string]: string; } | undefined;
}

export interface TrajetDto {
    id?: string;
    etapes?: EtapeDto[] | undefined;
    artistes?: ArtisteLightDto[] | undefined;
    versementArtistes?: VersementArtisteLightDto[] | undefined;
}

export interface TrajetDtoSortedFilteredPage {
    readonly actualCount?: number;
    readonly items?: TrajetDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
    readonly sortTerms?: SortTerm[] | undefined;
    readonly filterTerms?: FilterTerm[] | undefined;
}

export interface TrajetValidationDto {
    dossierWithoutTrajet?: boolean;
    trajetWithoutArtiste?: boolean;
    noTrajetFromAimableToAimable?: boolean;
}

export interface TrajetViewModelDto {
    trajets?: TrajetDtoSortedFilteredPage;
    document?: DocumentDto;
}

export enum TypeContrat {
    None = "none",
    Cdi = "cdi",
    Cdd = "cdd",
    Cdii = "cdii",
    Autre = "autre",
}

export interface TypeDeDocumentDto {
    id?: string;
    code?: string | undefined;
    nom?: { [key: string]: string; } | undefined;
    hasAttachment?: boolean;
    isRequired?: boolean;
    isRequiredInVersement?: boolean;
    /** ISO 8601 duration */
    expirationPeriod?: string | undefined;
    expirationRelativeTo?: string | undefined;
    hasChoix?: boolean;
    isChoix?: boolean;
    scope?: DocumentScope;
    canBeDeleted?: boolean;
    choix?: TypeDeDocumentDto[] | undefined;
    extraInfos?: TypeDeDocumentExtraInfoDto[] | undefined;
    selectedNom?: { [key: string]: string; } | undefined;
}

export interface TypeDeDocumentExtraInfoDto {
    code?: string | undefined;
    nom?: { [key: string]: string; } | undefined;
    valueType?: TypeDeDocumentExtraInfoValueType;
    isRequired?: boolean;
}

export enum TypeDeDocumentExtraInfoValueType {
    String = "string",
    Date = "date",
}

export enum TypeDepense {
    None = "none",
    Autre = "autre",
    BudgetPrevisionnelDepenses = "budgetPrevisionnelDepenses",
    SalaireAutrePersonnel = "salaireAutrePersonnel",
    AutresDepenses = "autresDepenses",
    BudgetRepetitionsEtEnregistrements = "budgetRepetitionsEtEnregistrements",
    BudgetScenique = "budgetScenique",
    Promotion = "promotion",
    Salles = "salles",
    FraisDeplacement = "fraisDeplacement",
    ContratsVenteEtAutreSalairePersonnel = "contratsVenteEtAutreSalairePersonnel",
    AutreMasseSalariale = "autreMasseSalariale",
    FraisDePersonnel = "fraisDePersonnel",
    AutresFraisDePersonnel = "autresFraisDePersonnel",
    ServicesExterieurs = "servicesExterieurs",
    ImpotsTaxes = "impotsTaxes",
    FraisDeRealisationDuDocumentDePromotion = "fraisDeRealisationDuDocumentDePromotion",
    Droits = "droits",
    BudgetPrevisionnelAnnulations = "budgetPrevisionnelAnnulations",
}

export enum TypeFinancement {
    None = "none",
    Autre = "autre",
    RecettesPropres = "recettesPropres",
    FinancementPublic = "financementPublic",
    SubventionsOrganismesProfessionnels = "subventionsOrganismesProfessionnels",
    SubventionsEtatCollectivitesTerritoriales = "subventionsEtatCollectivitesTerritoriales",
}

export enum TypePoste {
    None = "none",
    Administrateur = "administrateur",
    Tresorier = "tresorier",
    SecretaireAdministratif = "secretaireAdministratif",
    Directeur = "directeur",
    President = "president",
    Gerant = "gerant",
}

export enum TypePrestation {
    None = "none",
    Repetition = "repetition",
    Enregistrement = "enregistrement",
    Representation = "representation",
    Diffusion = "diffusion",
    Concert = "concert",
}

export enum TypesAdresses {
    None = "none",
    AdresseSiege = "adresseSiege",
    AdressePersonnelle = "adressePersonnelle",
    Autre = "autre",
}

export enum TypeTransport {
    None = "none",
    Voiture = "voiture",
    Train = "train",
    Avion = "avion",
}

export enum TypeVersement {
    None = "none",
    Acompte = "acompte",
    Solde = "solde",
    Complet = "complet",
    Complementaire = "complementaire",
}

export interface Unit {
}

export interface UpdateArtisteDto {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    siteInternet?: string | undefined;
    emploi?: Emploi;
    styleMusicalId?: string | undefined;
    instrumentId?: string | undefined;
    artistePrincipal?: boolean;
    formation?: string | undefined;
    isGenerationSpedidam?: boolean;
    isAssociated?: boolean;
    isTitulaire?: boolean;
    isEngagementDirect?: boolean;
    cachets?: UpdateCachetDto[] | undefined;
    salaires?: UpdateSalaireDto[] | undefined;
}

export interface UpdateCachetDto {
    id?: string | undefined;
    lieuDateIds?: string[] | undefined;
    montantBrut?: number;
    tauxChargesPatronales?: number;
    count?: number;
}

export interface UpdateContactDto {
    poste?: TypePoste;
    civilite?: Civilite;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
}

export interface UpdateDepenseDto {
    id?: string | undefined;
    intitule?: string | undefined;
    commentaire?: string | undefined;
    type?: TypeDepense;
    champ?: ChampDepense;
    montant?: number;
    montantRealise?: number | undefined;
    confirmationMontant?: boolean | undefined;
    document?: DocumentUploadInfoDto;
}

export interface UpdateEnseignantRemunerationDto {
    id?: string;
    remunerationPremierTrimestre?: number;
    justificatifRemuneration?: DocumentUploadInfoDto;
}

export interface UpdateFinancementDto {
    id?: string | undefined;
    intitule?: string | undefined;
    commentaire?: string | undefined;
    type?: TypeFinancement;
    champ?: ChampFinancement;
    montant?: number;
    confirmationMontant?: boolean | undefined;
    document?: DocumentUploadInfoDto;
}

export interface UpdateLieuDto {
    adresseId?: string | undefined;
    adresseLabel?: string | undefined;
    departement?: string | undefined;
    ville?: string | undefined;
    paysId?: string;
    adresse?: string | undefined;
    nomLieu?: string | undefined;
    jauge?: number | undefined;
    dates?: LieuDateDto[] | undefined;
    typePrestation?: TypePrestation;
    description?: string;
}

export interface UpdateSalaireDto {
    id?: string | undefined;
    lieuDateIds?: string[] | undefined;
    montantBrut?: number;
    tauxChargesPatronales?: number;
}

export interface UpdateStructureAdresseDto {
    codeLangue?: string | undefined;
    parDefaut?: boolean;
    autre?: CreateOrUpdateAdresseDto;
}

export interface UpdateStructureContactDto {
    parDefaut?: boolean;
    autre?: UpdateContactDto;
}

export interface UpdateStructureInformationsDto {
    informations?: string | undefined;
}

export interface UpdateStructureJuridiqueDto {
    raisonSociale?: string | undefined;
    siret?: string | undefined;
    nomResponsable?: string | undefined;
    prenomResponsable?: string | undefined;
    telephoneFixe?: string | undefined;
    telephonePortable?: string | undefined;
    emailResponsable?: string | undefined;
    adresse?: CreateOrUpdateAdresseDto;
    formeJuridique?: FormeJuridiqueDto;
    codeAPE?: string | undefined;
}

export interface UpdateStructureValidationContactsDto {
    president?: UpdateContactDto;
    adresse?: CreateOrUpdateAdresseDto;
    correspondant?: UpdateContactDto;
    adresseCorrespondance?: CreateOrUpdateAdresseDto;
}

export interface UpdateVersementArtisteDocumentDto {
    id?: string;
    bulletin?: DocumentUploadInfoDto;
    contrat?: DocumentUploadInfoDto;
}

export interface UpdateVersementCommentaireDto {
    commentaire?: string | undefined;
}

export interface VersementArtisteDto {
    id?: string;
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    dateTravaillees?: string | undefined;
    totalSalairesBruts?: number;
    totalCharges?: number;
    emploi?: Emploi;
    styleMusical?: StyleMusicalDto;
    instrument?: InstrumentDto;
    isTitulaire?: boolean;
    createdAt?: Date;
    lastModifiedAt?: Date | undefined;
    contrat?: DocumentWithValidationDto;
    bulletin?: DocumentWithValidationDto;
    datesTravailles?: Date[] | undefined;
}

export interface VersementArtisteLightDto {
    id?: string;
    artisteId?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    lieuHabitation?: string | undefined;
    emploi?: Emploi;
    isTitulaire?: boolean;
}

export interface VersementArtisteLightDtoSortedFilteredPage {
    readonly actualCount?: number;
    readonly items?: VersementArtisteLightDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
    readonly sortTerms?: SortTerm[] | undefined;
    readonly filterTerms?: FilterTerm[] | undefined;
}

export interface VersementDto {
    id?: string;
    statutVersement?: StatutVersement;
    typeVersement?: TypeVersement;
    modeVersement?: ModeVersement;
    createdAt?: Date;
    dateSoumission?: Date | undefined;
    dateDerniereSoumission?: Date | undefined;
    dossierId?: string;
}

export interface VersementDtoSortedFilteredPage {
    readonly actualCount?: number;
    readonly items?: VersementDto[] | undefined;
    readonly number?: number;
    readonly requestedSize?: number;
    readonly totalPageCount?: number;
    readonly totalItemCount?: number;
    readonly disablePagination?: boolean;
    readonly hasPrevious?: boolean;
    readonly previousPageNumber?: number | undefined;
    readonly hasNext?: boolean;
    readonly nextPageNumber?: number | undefined;
    readonly isFirst?: boolean;
    readonly isLast?: boolean;
    readonly sortTerms?: SortTerm[] | undefined;
    readonly filterTerms?: FilterTerm[] | undefined;
}

export enum ProblemDetailsCode {
    Unknown = "unknown",
    InvalidParameters = "invalidParameters",
    PreconditionFailed = "preconditionFailed",
    AccessDenied = "accessDenied",
    Unauthorized = "unauthorized",
    Forbidden = "forbidden",
    EntityNotFound = "entityNotFound",
    EmailingServiceUnavailable = "emailingServiceUnavailable",
    SiretNotFound = "siretNotFound",
    MissingDocument = "missingDocument",
    MissingDocumentExtraInfo = "missingDocumentExtraInfo",
    InvalidDocument = "invalidDocument",
    InvalidDocumentExtraInfoValue = "invalidDocumentExtraInfoValue",
    DocumentExpired = "documentExpired",
    InvalidLanguage = "invalidLanguage",
    CannotResetStatutStructure = "cannotResetStatutStructure",
    CannotModifyActiveCritereDossier = "cannotModifyActiveCritereDossier",
    CannotDeleteNonEmptyCategory = "cannotDeleteNonEmptyCategory",
    EntityAlreadyExists = "entityAlreadyExists",
    EntitiesNotFound = "entitiesNotFound",
    StructurePending = "structurePending",
    StructureDisabled = "structureDisabled",
    InvalidPrestation = "invalidPrestation",
    CategorieDossierQuotaExceeded = "categorieDossierQuotaExceeded",
    ForbiddenCategorieDossier = "forbiddenCategorieDossier",
    NotImplemented = "notImplemented",
    BudgetNotBalanced = "budgetNotBalanced",
    MontantAideMustBeInferior = "montantAideMustBeInferior",
    MontantAideMustBeSuperior = "montantAideMustBeSuperior",
    MontantAideMustBeInferiorOrEqual = "montantAideMustBeInferiorOrEqual",
    MontantDepenseMustBeInferior = "montantDepenseMustBeInferior",
    MontantDepenseMustBeSuperiorOrEqualException = "montantDepenseMustBeSuperiorOrEqualException",
    MontantFinancementMustBeInferior = "montantFinancementMustBeInferior",
    MontantFinancementMustBeSuperiorOrEqual = "montantFinancementMustBeSuperiorOrEqual",
    InvalidAnswers = "invalidAnswers",
    AdresseNotFound = "adresseNotFound",
    MissingFile = "missingFile",
    InvalidIban = "invalidIban",
    MinimumRemuneration = "minimumRemuneration",
    InvalidStatutDossierChange = "invalidStatutDossierChange",
    CannotUpdateDossier = "cannotUpdateDossier",
    CannotDeleteDossier = "cannotDeleteDossier",
    CannotDeleteVersement = "cannotDeleteVersement",
    MaximumDates = "maximumDates",
    MaxRangeBetweenDatesExceeded = "maxRangeBetweenDatesExceeded",
    DateCAMustBeSuperiorToDateDebutCommission = "dateCAMustBeSuperiorToDateDebutCommission",
    DateFinMustBeSuperiorToDateDebutCommission = "dateFinMustBeSuperiorToDateDebutCommission",
    DateFinSoumissionMustBeInferiorToDateDebutCommission = "dateFinSoumissionMustBeInferiorToDateDebutCommission",
    DateDebutDossierMustBeSuperiorToDateFinCommission = "dateDebutDossierMustBeSuperiorToDateFinCommission",
    CommissionWithSameDateDebutExistsException = "commissionWithSameDateDebutExistsException",
    CannotUpdateCommissionWithDossiersException = "cannotUpdateCommissionWithDossiersException",
    EmailAlreadyUsed = "emailAlreadyUsed",
    InvalidStatutCommission = "invalidStatutCommission",
    InvalidStatutDossierToChangeCommission = "invalidStatutDossierToChangeCommission",
    CannotUpdateCommissionStatut = "cannotUpdateCommissionStatut",
    CannotOpenCommission = "cannotOpenCommission",
    CannotPrendreEnchargeDossier = "cannotPrendreEnchargeDossier",
    CannotPrendreEnchargeDemandeVersement = "cannotPrendreEnchargeDemandeVersement",
    DossiersNonValideEnCommission = "dossiersNonValideEnCommission",
    CommissionsMembersAreNotSet = "commissionsMembersAreNotSet",
    DateFinSoumissionMustBePassed = "dateFinSoumissionMustBePassed",
    MinCachetRequired = "minCachetRequired",
    PeriodStartDateShouldBeAfterCommissionEnding = "periodStartDateShouldBeAfterCommissionEnding",
    DateEmbaucheIsNotValid = "dateEmbaucheIsNotValid",
    DossierIsNotValid = "dossierIsNotValid",
    CannotRenounceDossier = "cannotRenounceDossier",
    InvalidBordereauStatus = "invalidBordereauStatus",
    BordereauAmendableMaxExceeded = "bordereauAmendableMaxExceeded",
    CannotCloseBordereau = "cannotCloseBordereau",
    CannotArchiveBordereau = "cannotArchiveBordereau",
    InvalidOperation = "invalidOperation",
    CannotDeleteMouvementBordereauVerse = "cannotDeleteMouvementBordereauVerse",
    CannotDeleteMouvementBordereau = "cannotDeleteMouvementBordereau",
    BordereauStillAmendable = "bordereauStillAmendable",
    BordereauReaffectationStillAmendable = "bordereauReaffectationStillAmendable",
    CannotFigerCommissionWithOutstandingDossiers = "cannotFigerCommissionWithOutstandingDossiers",
    CannotProgrammerEnCommissionDossierCommissionClosed = "cannotProgrammerEnCommissionDossierCommissionClosed",
    CannotProgrammerEnCommissionDossierCACommissionClosed = "cannotProgrammerEnCommissionDossierCACommissionClosed",
    CannotUpdateCommissionContent = "cannotUpdateCommissionContent",
    CannotUpdateCommissionCAContent = "cannotUpdateCommissionCAContent",
    CannotCreateCritereDossierOnCommissionSpecifique = "cannotCreateCritereDossierOnCommissionSpecifique",
    InvalidDate = "invalidDate",
}

export interface AdditionalDetails {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

function appendFileDictionary(formData: FormData, documents: any) {
    throw new Error('Function not implemented.');
}
